window.overviewAnimation4 = {
    "nm": "animation",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "Animation",
            "sr": 1,
            "st": -7,
            "op": 4832,
            "ip": 0,
            "ln": "803",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        }
    ],
    "v": "5.7.0",
    "fr": 60,
    "op": 257,
    "ip": 4,
    "fonts": {
        "list": [
            {
                "ascent": null,
                "fClass": "",
                "fFamily": "BDO Grotesk",
                "fStyle": "Medium",
                "fName": "BDOGrotesk-Medium",
                "fPath": "",
                "fWeight": "",
                "origin": 0
            }
        ]
    },
    "chars": [
        {
            "ch": "D",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 75.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.966666666666669,
                                                -2.9666666666666686
                                            ],
                                            [
                                                -2.699999999999998,
                                                -5.466666666666669
                                            ],
                                            [
                                                0,
                                                -7.466666666666669
                                            ],
                                            [
                                                2.5999999999999943,
                                                -5.466666666666669
                                            ],
                                            [
                                                4.966666666666669,
                                                -3.0666666666666664
                                            ],
                                            [
                                                7.1333333333333355,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                6.933333333333333,
                                                0
                                            ],
                                            [
                                                4.966666666666669,
                                                2.9666666666666686
                                            ],
                                            [
                                                2.699999999999998,
                                                5.466666666666664
                                            ],
                                            [
                                                0,
                                                7.199999999999998
                                            ],
                                            [
                                                -2.6000000000000036,
                                                5.466666666666666
                                            ],
                                            [
                                                -4.966666666666664,
                                                3.0666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                38.4,
                                                0
                                            ],
                                            [
                                                8.2,
                                                0
                                            ],
                                            [
                                                8.2,
                                                -72.9
                                            ],
                                            [
                                                38.4,
                                                -72.9
                                            ],
                                            [
                                                56.25,
                                                -68.45
                                            ],
                                            [
                                                67.75,
                                                -55.8
                                            ],
                                            [
                                                71.8,
                                                -36.4
                                            ],
                                            [
                                                67.9,
                                                -17.4
                                            ],
                                            [
                                                56.55,
                                                -4.6
                                            ],
                                            [
                                                38.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.199999999999998,
                                                2.0666666666666664
                                            ],
                                            [
                                                -1.7000000000000028,
                                                3.900000000000001
                                            ],
                                            [
                                                0,
                                                5.400000000000001
                                            ],
                                            [
                                                1.6999999999999982,
                                                3.866666666666665
                                            ],
                                            [
                                                3.1666666666666665,
                                                2.066666666666663
                                            ],
                                            [
                                                4.599999999999999,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.533333333333336,
                                                0
                                            ],
                                            [
                                                3.199999999999998,
                                                -2.0666666666666664
                                            ],
                                            [
                                                1.6999999999999982,
                                                -3.8999999999999986
                                            ],
                                            [
                                                0,
                                                -5.400000000000001
                                            ],
                                            [
                                                -1.7000000000000028,
                                                -3.8666666666666694
                                            ],
                                            [
                                                -3.1666666666666665,
                                                -2.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                20.1,
                                                -64.7
                                            ],
                                            [
                                                20.1,
                                                -8.2
                                            ],
                                            [
                                                17.8,
                                                -10.5
                                            ],
                                            [
                                                37.9,
                                                -10.5
                                            ],
                                            [
                                                49.5,
                                                -13.6
                                            ],
                                            [
                                                56.85,
                                                -22.55
                                            ],
                                            [
                                                59.4,
                                                -36.5
                                            ],
                                            [
                                                56.85,
                                                -50.4
                                            ],
                                            [
                                                49.55,
                                                -59.3
                                            ],
                                            [
                                                37.9,
                                                -62.4
                                            ],
                                            [
                                                17.8,
                                                -62.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "o",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.099999999999999,
                                                2.466666666666667
                                            ],
                                            [
                                                2.266666666666666,
                                                4.333333333333333
                                            ],
                                            [
                                                0,
                                                5.866666666666667
                                            ],
                                            [
                                                -2.2666666666666666,
                                                4.400000000000001
                                            ],
                                            [
                                                -4.133333333333333,
                                                2.433333333333337
                                            ],
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.099999999999999,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -2.2333333333333343,
                                                -4.399999999999996
                                            ],
                                            [
                                                0,
                                                -5.866666666666667
                                            ],
                                            [
                                                2.2333333333333343,
                                                -4.366666666666666
                                            ],
                                            [
                                                4.099999999999999,
                                                -2.433333333333333
                                            ],
                                            [
                                                5.533333333333334,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.533333333333334,
                                                0
                                            ],
                                            [
                                                -4.100000000000001,
                                                -2.466666666666667
                                            ],
                                            [
                                                -2.2666666666666666,
                                                -4.333333333333332
                                            ],
                                            [
                                                0,
                                                -5.9333333333333345
                                            ],
                                            [
                                                2.266666666666666,
                                                -4.399999999999996
                                            ],
                                            [
                                                4.1333333333333355,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.533333333333334,
                                                0
                                            ],
                                            [
                                                4.099999999999999,
                                                2.433333333333337
                                            ],
                                            [
                                                2.2333333333333343,
                                                4.400000000000001
                                            ],
                                            [
                                                0,
                                                5.9333333333333345
                                            ],
                                            [
                                                -2.2333333333333343,
                                                4.366666666666666
                                            ],
                                            [
                                                -4.099999999999999,
                                                2.433333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.3,
                                                1
                                            ],
                                            [
                                                16.85,
                                                -2.7
                                            ],
                                            [
                                                7.3,
                                                -12.9
                                            ],
                                            [
                                                3.9,
                                                -28.2
                                            ],
                                            [
                                                7.3,
                                                -43.7
                                            ],
                                            [
                                                16.9,
                                                -53.95
                                            ],
                                            [
                                                31.3,
                                                -57.6
                                            ],
                                            [
                                                45.75,
                                                -53.95
                                            ],
                                            [
                                                55.25,
                                                -43.7
                                            ],
                                            [
                                                58.6,
                                                -28.3
                                            ],
                                            [
                                                55.25,
                                                -12.85
                                            ],
                                            [
                                                45.75,
                                                -2.65
                                            ],
                                            [
                                                31.3,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.7333333333333294,
                                                3.4333333333333322
                                            ],
                                            [
                                                0,
                                                6.199999999999998
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.366666666666665
                                            ],
                                            [
                                                4.9333333333333345,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.4666666666666637
                                            ],
                                            [
                                                0,
                                                -6.0666666666666655
                                            ],
                                            [
                                                -2.733333333333333,
                                                -3.4
                                            ],
                                            [
                                                -5,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.9333333333333345,
                                                0
                                            ],
                                            [
                                                2.7333333333333343,
                                                -3.433333333333335
                                            ],
                                            [
                                                0,
                                                -6.200000000000003
                                            ],
                                            [
                                                -2.7333333333333294,
                                                -3.366666666666665
                                            ],
                                            [
                                                -4.9333333333333345,
                                                0
                                            ],
                                            [
                                                -2.766666666666667,
                                                3.4666666666666686
                                            ],
                                            [
                                                0,
                                                6.2
                                            ],
                                            [
                                                2.7333333333333343,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.3,
                                                -8.8
                                            ],
                                            [
                                                42.8,
                                                -13.95
                                            ],
                                            [
                                                46.9,
                                                -28.4
                                            ],
                                            [
                                                42.8,
                                                -42.75
                                            ],
                                            [
                                                31.3,
                                                -47.8
                                            ],
                                            [
                                                19.75,
                                                -42.6
                                            ],
                                            [
                                                15.6,
                                                -28.3
                                            ],
                                            [
                                                19.7,
                                                -13.9
                                            ],
                                            [
                                                31.3,
                                                -8.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "n",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9666666666666663,
                                                1.5
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                -6.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.900000000000001,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.799999999999997,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.2666666666666657,
                                                -2.0666666666666678
                                            ],
                                            [
                                                0.06666666666666761,
                                                -2.799999999999997
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.3333333333333335,
                                                -3.200000000000003
                                            ],
                                            [
                                                2.9666666666666663,
                                                -1.5
                                            ],
                                            [
                                                5.733333333333334,
                                                0
                                            ],
                                            [
                                                3.6000000000000036,
                                                3.2666666666666706
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.3333333333333335
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2.5333333333333363,
                                                0
                                            ],
                                            [
                                                -2.1666666666666665,
                                                1.099999999999999
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.5,
                                                -56.6
                                            ],
                                            [
                                                18.1,
                                                -48.3
                                            ],
                                            [
                                                26.05,
                                                -55.35
                                            ],
                                            [
                                                36.3,
                                                -57.6
                                            ],
                                            [
                                                50.3,
                                                -52.7
                                            ],
                                            [
                                                55.7,
                                                -37.9
                                            ],
                                            [
                                                55.7,
                                                0
                                            ],
                                            [
                                                44.1,
                                                0
                                            ],
                                            [
                                                44.1,
                                                -36.5
                                            ],
                                            [
                                                41.25,
                                                -44.4
                                            ],
                                            [
                                                32.7,
                                                -47.3
                                            ],
                                            [
                                                25.65,
                                                -45.65
                                            ],
                                            [
                                                20.5,
                                                -40.9
                                            ],
                                            [
                                                18.5,
                                                -33.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "e",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 59.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.133333333333333,
                                                2.3000000000000003
                                            ],
                                            [
                                                2.3000000000000007,
                                                4.366666666666666
                                            ],
                                            [
                                                0,
                                                6.133333333333333
                                            ],
                                            [
                                                -2.166666666666667,
                                                4.400000000000001
                                            ],
                                            [
                                                -4.033333333333332,
                                                2.433333333333337
                                            ],
                                            [
                                                -5.666666666666667,
                                                0
                                            ],
                                            [
                                                -4,
                                                -2.400000000000001
                                            ],
                                            [
                                                -2.0333333333333314,
                                                -4.799999999999997
                                            ],
                                            [
                                                0.5333333333333314,
                                                -7.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                3.433333333333337
                                            ],
                                            [
                                                4.999999999999997,
                                                0
                                            ],
                                            [
                                                2.866666666666667,
                                                -3.200000000000003
                                            ],
                                            [
                                                0,
                                                -7
                                            ],
                                            [
                                                -2.8000000000000007,
                                                -3.2666666666666657
                                            ],
                                            [
                                                -5.133333333333333,
                                                0
                                            ],
                                            [
                                                -2.4666666666666686,
                                                1.7666666666666668
                                            ],
                                            [
                                                -0.6000000000000038,
                                                3.2000000000000006
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.2333333333333343,
                                                -2.5333333333333337
                                            ],
                                            [
                                                3.400000000000001,
                                                -1.4333333333333333
                                            ],
                                            [
                                                4.400000000000001,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -5.466666666666666,
                                                0
                                            ],
                                            [
                                                -4.133333333333333,
                                                -2.3000000000000003
                                            ],
                                            [
                                                -2.3,
                                                -4.366666666666667
                                            ],
                                            [
                                                0,
                                                -5.9333333333333345
                                            ],
                                            [
                                                2.1666666666666665,
                                                -4.399999999999996
                                            ],
                                            [
                                                4.033333333333334,
                                                -2.4333333333333322
                                            ],
                                            [
                                                5.466666666666669,
                                                0
                                            ],
                                            [
                                                4,
                                                2.400000000000001
                                            ],
                                            [
                                                2.0333333333333314,
                                                4.800000000000002
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.8666666666666695,
                                                -5.666666666666664
                                            ],
                                            [
                                                -2.433333333333337,
                                                -3.4333333333333322
                                            ],
                                            [
                                                -4.533333333333334,
                                                0
                                            ],
                                            [
                                                -2.866666666666666,
                                                3.199999999999998
                                            ],
                                            [
                                                0,
                                                6.866666666666667
                                            ],
                                            [
                                                2.7999999999999994,
                                                3.266666666666667
                                            ],
                                            [
                                                3.9333333333333322,
                                                0
                                            ],
                                            [
                                                2.4666666666666637,
                                                -1.7666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6666666666666666,
                                                3.4
                                            ],
                                            [
                                                -2.2333333333333294,
                                                2.533333333333333
                                            ],
                                            [
                                                -3.400000000000001,
                                                1.4333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.4,
                                                1
                                            ],
                                            [
                                                17,
                                                -2.45
                                            ],
                                            [
                                                7.35,
                                                -12.45
                                            ],
                                            [
                                                3.9,
                                                -28.2
                                            ],
                                            [
                                                7.15,
                                                -43.7
                                            ],
                                            [
                                                16.45,
                                                -53.95
                                            ],
                                            [
                                                31,
                                                -57.6
                                            ],
                                            [
                                                45.2,
                                                -54
                                            ],
                                            [
                                                54.25,
                                                -43.2
                                            ],
                                            [
                                                56.5,
                                                -25.3
                                            ],
                                            [
                                                13.8,
                                                -25.3
                                            ],
                                            [
                                                13.8,
                                                -33.7
                                            ],
                                            [
                                                49,
                                                -33.7
                                            ],
                                            [
                                                44.3,
                                                -29.8
                                            ],
                                            [
                                                41.95,
                                                -43.45
                                            ],
                                            [
                                                30.8,
                                                -48.6
                                            ],
                                            [
                                                19.7,
                                                -43.8
                                            ],
                                            [
                                                15.4,
                                                -28.5
                                            ],
                                            [
                                                19.6,
                                                -13.3
                                            ],
                                            [
                                                31.5,
                                                -8.4
                                            ],
                                            [
                                                41.1,
                                                -11.05
                                            ],
                                            [
                                                45.7,
                                                -18.5
                                            ],
                                            [
                                                55.9,
                                                -16
                                            ],
                                            [
                                                51.55,
                                                -7.1
                                            ],
                                            [
                                                43.1,
                                                -1.15
                                            ],
                                            [
                                                31.4,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": ".",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 22.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                17.1,
                                                0
                                            ],
                                            [
                                                5.5,
                                                0
                                            ],
                                            [
                                                5.5,
                                                -12.3
                                            ],
                                            [
                                                17.1,
                                                -12.3
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": " ",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 23,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": []
                    }
                ]
            }
        },
        {
            "ch": "Y",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 65.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                38.8,
                                                0
                                            ],
                                            [
                                                27,
                                                0
                                            ],
                                            [
                                                27,
                                                -30.7
                                            ],
                                            [
                                                -0.6,
                                                -72.9
                                            ],
                                            [
                                                13.5,
                                                -72.9
                                            ],
                                            [
                                                33,
                                                -41.4
                                            ],
                                            [
                                                52.7,
                                                -72.9
                                            ],
                                            [
                                                66.4,
                                                -72.9
                                            ],
                                            [
                                                38.8,
                                                -30.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "u",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.433333333333335,
                                                3.5
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2,
                                                -1.8000000000000007
                                            ],
                                            [
                                                -3.3333333333333335,
                                                0
                                            ],
                                            [
                                                -2.066666666666663,
                                                1.1000000000000003
                                            ],
                                            [
                                                -1.1666666666666667,
                                                1.9666666666666675
                                            ],
                                            [
                                                -0.06666666666666761,
                                                2.6666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.0333333333333363,
                                                -1.6333333333333335
                                            ],
                                            [
                                                3.6000000000000014,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -6.399999999999999,
                                                0
                                            ],
                                            [
                                                -3.433333333333333,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.3999999999999986
                                            ],
                                            [
                                                2,
                                                1.7999999999999996
                                            ],
                                            [
                                                2.800000000000002,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.1666666666666667,
                                                -1.9666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.7999999999999972,
                                                2.9333333333333336
                                            ],
                                            [
                                                -3.0333333333333314,
                                                1.6333333333333335
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                26.7,
                                                1
                                            ],
                                            [
                                                11.95,
                                                -4.25
                                            ],
                                            [
                                                6.8,
                                                -18.5
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -19.9
                                            ],
                                            [
                                                21.5,
                                                -12.1
                                            ],
                                            [
                                                29.5,
                                                -9.4
                                            ],
                                            [
                                                36.8,
                                                -11.05
                                            ],
                                            [
                                                41.65,
                                                -15.65
                                            ],
                                            [
                                                43.5,
                                                -22.6
                                            ],
                                            [
                                                43.5,
                                                -56.6
                                            ],
                                            [
                                                55.2,
                                                -56.6
                                            ],
                                            [
                                                55.2,
                                                0
                                            ],
                                            [
                                                44.4,
                                                0
                                            ],
                                            [
                                                43.9,
                                                -8.3
                                            ],
                                            [
                                                36.65,
                                                -1.45
                                            ],
                                            [
                                                26.7,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\xe2\x80\x99",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 22.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6333333333333329,
                                                0.8666666666666648
                                            ],
                                            [
                                                0,
                                                1.3333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8333333333333346,
                                                -1.5666666666666629
                                            ],
                                            [
                                                3.133333333333333,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.8666666666666671,
                                                0
                                            ],
                                            [
                                                0.6333333333333329,
                                                -0.8666666666666648
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.2666666666666706
                                            ],
                                            [
                                                -1.8333333333333333,
                                                1.5666666666666675
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                6.9,
                                                -47.1
                                            ],
                                            [
                                                4.6,
                                                -47.1
                                            ],
                                            [
                                                4.6,
                                                -53.2
                                            ],
                                            [
                                                6.5,
                                                -53.2
                                            ],
                                            [
                                                10.25,
                                                -54.5
                                            ],
                                            [
                                                11.2,
                                                -57.8
                                            ],
                                            [
                                                11.2,
                                                -61.5
                                            ],
                                            [
                                                5.5,
                                                -61.5
                                            ],
                                            [
                                                5.5,
                                                -73.8
                                            ],
                                            [
                                                17.1,
                                                -73.8
                                            ],
                                            [
                                                17.1,
                                                -56.7
                                            ],
                                            [
                                                14.35,
                                                -49.45
                                            ],
                                            [
                                                6.9,
                                                -47.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "r",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 36.7,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.2999999999999994,
                                                1.5666666666666675
                                            ],
                                            [
                                                -3,
                                                0
                                            ],
                                            [
                                                -1.1333333333333304,
                                                -0.3999999999999962
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.7333333333333295,
                                                0.09999999999999905
                                            ],
                                            [
                                                0.7333333333333343,
                                                0
                                            ],
                                            [
                                                2.2666666666666657,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0.40000000000000097,
                                                -3.7333333333333294
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666661,
                                                -3
                                            ],
                                            [
                                                2.300000000000002,
                                                -1.5666666666666629
                                            ],
                                            [
                                                2,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.5333333333333362,
                                                -0.1999999999999981
                                            ],
                                            [
                                                -0.7333333333333343,
                                                -0.09999999999999905
                                            ],
                                            [
                                                -3.7333333333333343,
                                                0
                                            ],
                                            [
                                                -2.2666666666666657,
                                                2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.3,
                                                -56.6
                                            ],
                                            [
                                                18,
                                                -48.1
                                            ],
                                            [
                                                23.65,
                                                -54.95
                                            ],
                                            [
                                                31.6,
                                                -57.3
                                            ],
                                            [
                                                36.3,
                                                -56.7
                                            ],
                                            [
                                                36.3,
                                                -45.7
                                            ],
                                            [
                                                35.6,
                                                -45.7
                                            ],
                                            [
                                                33.7,
                                                -46.15
                                            ],
                                            [
                                                31.5,
                                                -46.3
                                            ],
                                            [
                                                22.5,
                                                -43.05
                                            ],
                                            [
                                                18.5,
                                                -34.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "w",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 81.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.1,
                                                0
                                            ],
                                            [
                                                17.5,
                                                0
                                            ],
                                            [
                                                1.2,
                                                -56.6
                                            ],
                                            [
                                                13.3,
                                                -56.6
                                            ],
                                            [
                                                24.1,
                                                -11.7
                                            ],
                                            [
                                                34.4,
                                                -56.6
                                            ],
                                            [
                                                47.2,
                                                -56.6
                                            ],
                                            [
                                                57.8,
                                                -12.3
                                            ],
                                            [
                                                68.4,
                                                -56.6
                                            ],
                                            [
                                                80.1,
                                                -56.6
                                            ],
                                            [
                                                64.1,
                                                0
                                            ],
                                            [
                                                50.9,
                                                0
                                            ],
                                            [
                                                40.8,
                                                -42.4
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "E",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 66.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                63.4,
                                                0
                                            ],
                                            [
                                                8.2,
                                                0
                                            ],
                                            [
                                                8.2,
                                                -72.9
                                            ],
                                            [
                                                60.4,
                                                -72.9
                                            ],
                                            [
                                                60.4,
                                                -62.7
                                            ],
                                            [
                                                20.1,
                                                -62.7
                                            ],
                                            [
                                                20.1,
                                                -10.3
                                            ],
                                            [
                                                63.4,
                                                -10.3
                                            ],
                                            [
                                                63.4,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                56.2,
                                                -32.3
                                            ],
                                            [
                                                18.5,
                                                -32.3
                                            ],
                                            [
                                                18.5,
                                                -42.2
                                            ],
                                            [
                                                56.2,
                                                -42.2
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "t",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 33,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.0333333333333337,
                                                1.7666666666666666
                                            ],
                                            [
                                                0,
                                                3.4
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.6000000000000014,
                                                -0.6999999999999993
                                            ],
                                            [
                                                -1.8666666666666671,
                                                0
                                            ],
                                            [
                                                -0.7666666666666657,
                                                0.10000000000000024
                                            ],
                                            [
                                                -0.5333333333333314,
                                                0.13333333333333286
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.4666666666666661,
                                                -0.16666666666666666
                                            ],
                                            [
                                                1.2666666666666682,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -3.9999999999999987,
                                                0
                                            ],
                                            [
                                                -2.0333333333333328,
                                                -1.7666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                2.0666666666666664
                                            ],
                                            [
                                                0.5999999999999991,
                                                0.7000000000000005
                                            ],
                                            [
                                                1,
                                                0
                                            ],
                                            [
                                                0.766666666666668,
                                                -0.10000000000000024
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.3333333333333333
                                            ],
                                            [
                                                -1.4666666666666661,
                                                0.16666666666666663
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                21.9,
                                                0.7
                                            ],
                                            [
                                                12.85,
                                                -1.95
                                            ],
                                            [
                                                9.8,
                                                -9.7
                                            ],
                                            [
                                                9.8,
                                                -72.1
                                            ],
                                            [
                                                21.2,
                                                -73.1
                                            ],
                                            [
                                                21.2,
                                                -14.2
                                            ],
                                            [
                                                22.1,
                                                -10.05
                                            ],
                                            [
                                                25.8,
                                                -9
                                            ],
                                            [
                                                28.45,
                                                -9.15
                                            ],
                                            [
                                                30.4,
                                                -9.5
                                            ],
                                            [
                                                30.4,
                                                -0.3
                                            ],
                                            [
                                                26,
                                                0.45
                                            ],
                                            [
                                                21.9,
                                                0.7
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                15.5,
                                                -47.9
                                            ],
                                            [
                                                2.3,
                                                -47.8
                                            ],
                                            [
                                                2.3,
                                                -56.6
                                            ],
                                            [
                                                15.5,
                                                -56.5
                                            ],
                                            [
                                                15.5,
                                                -47.9
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30.4,
                                                -56.6
                                            ],
                                            [
                                                30.4,
                                                -47.8
                                            ],
                                            [
                                                15.5,
                                                -47.9
                                            ],
                                            [
                                                15.5,
                                                -56.5
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "p",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 64.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.2999999999999994,
                                                1.8666666666666647
                                            ],
                                            [
                                                -4.199999999999998,
                                                0.2666666666666657
                                            ],
                                            [
                                                -3.6000000000000036,
                                                -2.200000000000003
                                            ],
                                            [
                                                -1.966666666666664,
                                                -4.266666666666666
                                            ],
                                            [
                                                0,
                                                -5.800000000000002
                                            ],
                                            [
                                                2,
                                                -4.333333333333333
                                            ],
                                            [
                                                3.6666666666666665,
                                                -2.3666666666666667
                                            ],
                                            [
                                                4.933333333333333,
                                                0.13333333333333333
                                            ],
                                            [
                                                3.2333333333333343,
                                                1.3333333333333333
                                            ],
                                            [
                                                1.8666666666666647,
                                                3.8000000000000007
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6666666666666667,
                                                -3.3333333333333335
                                            ],
                                            [
                                                3.300000000000002,
                                                -1.8666666666666696
                                            ],
                                            [
                                                4.933333333333333,
                                                0
                                            ],
                                            [
                                                3.599999999999999,
                                                2.199999999999998
                                            ],
                                            [
                                                1.9666666666666686,
                                                4.266666666666666
                                            ],
                                            [
                                                0,
                                                6
                                            ],
                                            [
                                                -2,
                                                4.333333333333333
                                            ],
                                            [
                                                -3.6666666666666665,
                                                2.3666666666666667
                                            ],
                                            [
                                                -4,
                                                0
                                            ],
                                            [
                                                -3.2333333333333343,
                                                -1.333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.1,
                                                16.5
                                            ],
                                            [
                                                6.8,
                                                16.5
                                            ],
                                            [
                                                6.8,
                                                -56.1
                                            ],
                                            [
                                                16.2,
                                                -56.1
                                            ],
                                            [
                                                18.2,
                                                -46.1
                                            ],
                                            [
                                                25.65,
                                                -53.9
                                            ],
                                            [
                                                36.9,
                                                -57.1
                                            ],
                                            [
                                                49.7,
                                                -53.8
                                            ],
                                            [
                                                58.05,
                                                -44.1
                                            ],
                                            [
                                                61,
                                                -29
                                            ],
                                            [
                                                58,
                                                -13.5
                                            ],
                                            [
                                                49.5,
                                                -3.45
                                            ],
                                            [
                                                36.6,
                                                -0.1
                                            ],
                                            [
                                                25.75,
                                                -2.1
                                            ],
                                            [
                                                18.1,
                                                -9.8
                                            ],
                                            [
                                                18.1,
                                                16.5
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.3666666666666671,
                                                -1.900000000000001
                                            ],
                                            [
                                                -2.566666666666665,
                                                -1.3999999999999997
                                            ],
                                            [
                                                -3.333333333333331,
                                                0
                                            ],
                                            [
                                                -2.7666666666666657,
                                                3.5666666666666678
                                            ],
                                            [
                                                0,
                                                6.733333333333334
                                            ],
                                            [
                                                2.7666666666666657,
                                                3.5333333333333314
                                            ],
                                            [
                                                5.066666666666667,
                                                0
                                            ],
                                            [
                                                2.5,
                                                -1.4666666666666686
                                            ],
                                            [
                                                1.3666666666666671,
                                                -2.599999999999999
                                            ],
                                            [
                                                0,
                                                -3.5333333333333337
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.06666666666666761,
                                                3.5333333333333314
                                            ],
                                            [
                                                1.3666666666666671,
                                                1.8999999999999997
                                            ],
                                            [
                                                2.5666666666666678,
                                                1.400000000000001
                                            ],
                                            [
                                                5.1333333333333355,
                                                0
                                            ],
                                            [
                                                2.7666666666666657,
                                                -3.566666666666665
                                            ],
                                            [
                                                0,
                                                -6.400000000000001
                                            ],
                                            [
                                                -2.7666666666666657,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -3.2666666666666657,
                                                0
                                            ],
                                            [
                                                -2.5,
                                                1.4666666666666686
                                            ],
                                            [
                                                -1.3666666666666671,
                                                2.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.4,
                                                -31.7
                                            ],
                                            [
                                                18.1,
                                                -23.4
                                            ],
                                            [
                                                20.05,
                                                -15.25
                                            ],
                                            [
                                                25.95,
                                                -10.3
                                            ],
                                            [
                                                34.8,
                                                -8.2
                                            ],
                                            [
                                                46.65,
                                                -13.55
                                            ],
                                            [
                                                50.8,
                                                -29
                                            ],
                                            [
                                                46.65,
                                                -43.9
                                            ],
                                            [
                                                34.9,
                                                -49.2
                                            ],
                                            [
                                                26.25,
                                                -47
                                            ],
                                            [
                                                20.45,
                                                -40.9
                                            ],
                                            [
                                                18.4,
                                                -31.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "i",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 25.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                -56.6
                                            ],
                                            [
                                                18.5,
                                                0
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.7,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -65.6
                                            ],
                                            [
                                                7.6,
                                                -78.8
                                            ],
                                            [
                                                18.7,
                                                -78.8
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "s",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 54.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.233333333333333,
                                                3.3000000000000003
                                            ],
                                            [
                                                0.2666666666666666,
                                                5.733333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.3333333333333335,
                                                -2.1
                                            ],
                                            [
                                                -4.066666666666667,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                1.2333333333333332
                                            ],
                                            [
                                                0,
                                                2.8000000000000007
                                            ],
                                            [
                                                0.8333333333333334,
                                                1.0333333333333339
                                            ],
                                            [
                                                1.5,
                                                0.5999999999999991
                                            ],
                                            [
                                                2,
                                                0.40000000000000097
                                            ],
                                            [
                                                2.3333333333333335,
                                                0.4666666666666662
                                            ],
                                            [
                                                2.5333333333333337,
                                                1.3666666666666647
                                            ],
                                            [
                                                1.2666666666666668,
                                                2.133333333333333
                                            ],
                                            [
                                                0,
                                                2.9333333333333322
                                            ],
                                            [
                                                -1.8000000000000007,
                                                2.4666666666666637
                                            ],
                                            [
                                                -3.2999999999999994,
                                                1.3666666666666647
                                            ],
                                            [
                                                -4.466666666666669,
                                                0
                                            ],
                                            [
                                                -3.300000000000002,
                                                -1.3000000000000018
                                            ],
                                            [
                                                -1.8999999999999961,
                                                -2.5333333333333363
                                            ],
                                            [
                                                -0.2666666666666657,
                                                -3.7333333333333343
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9666666666666686,
                                                1.8666666666666647
                                            ],
                                            [
                                                4.000000000000003,
                                                0
                                            ],
                                            [
                                                1.7333333333333343,
                                                -1.3333333333333333
                                            ],
                                            [
                                                0,
                                                -2.066666666666663
                                            ],
                                            [
                                                -1.099999999999999,
                                                -1.099999999999999
                                            ],
                                            [
                                                -2.2999999999999994,
                                                -0.6666666666666666
                                            ],
                                            [
                                                -3.5333333333333314,
                                                -0.7333333333333343
                                            ],
                                            [
                                                -2.2666666666666657,
                                                -0.766666666666668
                                            ],
                                            [
                                                -1.599999999999999,
                                                -1.2666666666666657
                                            ],
                                            [
                                                -0.8666666666666648,
                                                -1.9333333333333347
                                            ],
                                            [
                                                0,
                                                -2.866666666666667
                                            ],
                                            [
                                                3.900000000000001,
                                                -3.1333333333333333
                                            ],
                                            [
                                                8,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -7.266666666666666,
                                                0
                                            ],
                                            [
                                                -4.233333333333333,
                                                -3.3000000000000003
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.3333333333333335
                                            ],
                                            [
                                                2.3333333333333335,
                                                2.1
                                            ],
                                            [
                                                3.3999999999999986,
                                                0
                                            ],
                                            [
                                                2.0666666666666678,
                                                -1.2333333333333332
                                            ],
                                            [
                                                0,
                                                -1.7333333333333332
                                            ],
                                            [
                                                -0.8333333333333334,
                                                -1.0333333333333339
                                            ],
                                            [
                                                -1.5,
                                                -0.5999999999999991
                                            ],
                                            [
                                                -2,
                                                -0.40000000000000097
                                            ],
                                            [
                                                -3.7333333333333343,
                                                -0.8666666666666671
                                            ],
                                            [
                                                -2.5333333333333328,
                                                -1.3666666666666671
                                            ],
                                            [
                                                -1.2666666666666668,
                                                -2.133333333333335
                                            ],
                                            [
                                                0,
                                                -3.400000000000001
                                            ],
                                            [
                                                1.7999999999999996,
                                                -2.4666666666666686
                                            ],
                                            [
                                                3.2999999999999994,
                                                -1.3666666666666696
                                            ],
                                            [
                                                4.466666666666664,
                                                0
                                            ],
                                            [
                                                3.300000000000002,
                                                1.2999999999999972
                                            ],
                                            [
                                                1.900000000000001,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.133333333333335
                                            ],
                                            [
                                                -1.966666666666664,
                                                -1.8666666666666647
                                            ],
                                            [
                                                -3.133333333333333,
                                                0
                                            ],
                                            [
                                                -1.7333333333333318,
                                                1.3333333333333333
                                            ],
                                            [
                                                0,
                                                1.8666666666666696
                                            ],
                                            [
                                                1.1000000000000014,
                                                1.099999999999999
                                            ],
                                            [
                                                2.2999999999999994,
                                                0.6666666666666666
                                            ],
                                            [
                                                2.7333333333333343,
                                                0.5333333333333314
                                            ],
                                            [
                                                2.2666666666666706,
                                                0.766666666666668
                                            ],
                                            [
                                                1.599999999999999,
                                                1.2666666666666657
                                            ],
                                            [
                                                0.8666666666666695,
                                                1.9333333333333325
                                            ],
                                            [
                                                0,
                                                5.066666666666666
                                            ],
                                            [
                                                -3.900000000000001,
                                                3.1333333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                27.4,
                                                1
                                            ],
                                            [
                                                10.15,
                                                -3.95
                                            ],
                                            [
                                                3.4,
                                                -17.5
                                            ],
                                            [
                                                14.7,
                                                -18.8
                                            ],
                                            [
                                                18.2,
                                                -10.65
                                            ],
                                            [
                                                27.8,
                                                -7.5
                                            ],
                                            [
                                                36,
                                                -9.35
                                            ],
                                            [
                                                39.1,
                                                -15.4
                                            ],
                                            [
                                                37.85,
                                                -19.55
                                            ],
                                            [
                                                34.35,
                                                -22
                                            ],
                                            [
                                                29.1,
                                                -23.5
                                            ],
                                            [
                                                22.6,
                                                -24.8
                                            ],
                                            [
                                                13.2,
                                                -28.15
                                            ],
                                            [
                                                7.5,
                                                -33.4
                                            ],
                                            [
                                                5.6,
                                                -41
                                            ],
                                            [
                                                8.3,
                                                -49.8
                                            ],
                                            [
                                                15.95,
                                                -55.55
                                            ],
                                            [
                                                27.6,
                                                -57.6
                                            ],
                                            [
                                                39.25,
                                                -55.65
                                            ],
                                            [
                                                47.05,
                                                -49.9
                                            ],
                                            [
                                                50.3,
                                                -40.5
                                            ],
                                            [
                                                39.1,
                                                -39
                                            ],
                                            [
                                                36.15,
                                                -46.5
                                            ],
                                            [
                                                27.2,
                                                -49.3
                                            ],
                                            [
                                                19.9,
                                                -47.3
                                            ],
                                            [
                                                17.3,
                                                -42.2
                                            ],
                                            [
                                                18.95,
                                                -37.75
                                            ],
                                            [
                                                24.05,
                                                -35.1
                                            ],
                                            [
                                                32.8,
                                                -33
                                            ],
                                            [
                                                40.3,
                                                -31.05
                                            ],
                                            [
                                                46.1,
                                                -28
                                            ],
                                            [
                                                49.8,
                                                -23.2
                                            ],
                                            [
                                                51.1,
                                                -16
                                            ],
                                            [
                                                45.25,
                                                -3.7
                                            ],
                                            [
                                                27.4,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\xe2\x80\x94",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 87.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                80.6,
                                                -27.2
                                            ],
                                            [
                                                6.9,
                                                -27.2
                                            ],
                                            [
                                                6.9,
                                                -37.6
                                            ],
                                            [
                                                80.6,
                                                -37.6
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "\u0003",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 0
        },
        {
            "ch": "$",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 63.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.2,
                                                11.8
                                            ],
                                            [
                                                28.1,
                                                11.8
                                            ],
                                            [
                                                28.1,
                                                -7.1
                                            ],
                                            [
                                                36.2,
                                                -7.1
                                            ],
                                            [
                                                36.2,
                                                11.8
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                35.5,
                                                -7.1
                                            ],
                                            [
                                                28.6,
                                                -7.1
                                            ],
                                            [
                                                28.6,
                                                -66.6
                                            ],
                                            [
                                                35.5,
                                                -66.6
                                            ],
                                            [
                                                35.5,
                                                -7.1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                36.2,
                                                -66.6
                                            ],
                                            [
                                                28.1,
                                                -66.6
                                            ],
                                            [
                                                28.1,
                                                -84.9
                                            ],
                                            [
                                                36.2,
                                                -84.9
                                            ],
                                            [
                                                36.2,
                                                -66.6
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.3333333333333333,
                                                2
                                            ],
                                            [
                                                2.199999999999998,
                                                0.9333333333333371
                                            ],
                                            [
                                                2.866666666666665,
                                                0
                                            ],
                                            [
                                                2.2000000000000006,
                                                -1.7999999999999972
                                            ],
                                            [
                                                0,
                                                -2.933333333333337
                                            ],
                                            [
                                                -1.5,
                                                -1.4666666666666686
                                            ],
                                            [
                                                -2.699999999999998,
                                                -0.9000000000000009
                                            ],
                                            [
                                                -3.733333333333332,
                                                -0.7999999999999972
                                            ],
                                            [
                                                -2.6333333333333306,
                                                -0.9666666666666638
                                            ],
                                            [
                                                -2.1333333333333306,
                                                -1.5666666666666675
                                            ],
                                            [
                                                -1.1999999999999982,
                                                -2.4666666666666686
                                            ],
                                            [
                                                0,
                                                -3.6666666666666665
                                            ],
                                            [
                                                2.300000000000002,
                                                -3.2999999999999994
                                            ],
                                            [
                                                4.033333333333336,
                                                -1.7666666666666666
                                            ],
                                            [
                                                5.400000000000001,
                                                0
                                            ],
                                            [
                                                4.133333333333333,
                                                2
                                            ],
                                            [
                                                2.1999999999999997,
                                                3.5666666666666664
                                            ],
                                            [
                                                0.13333333333333344,
                                                4.733333333333334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.8999999999999986,
                                                -2.6999999999999993
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -2.4333333333333322,
                                                2.0333333333333328
                                            ],
                                            [
                                                0,
                                                3.4
                                            ],
                                            [
                                                1.400000000000001,
                                                1.5
                                            ],
                                            [
                                                2.2666666666666706,
                                                0.766666666666668
                                            ],
                                            [
                                                2.733333333333332,
                                                0.5999999999999991
                                            ],
                                            [
                                                3.099999999999999,
                                                1.1666666666666667
                                            ],
                                            [
                                                2.1666666666666665,
                                                1.6333333333333304
                                            ],
                                            [
                                                1.1333333333333329,
                                                2.3333333333333335
                                            ],
                                            [
                                                0,
                                                3.199999999999998
                                            ],
                                            [
                                                -2.0999999999999996,
                                                3.1000000000000036
                                            ],
                                            [
                                                -3.8000000000000007,
                                                1.6999999999999982
                                            ],
                                            [
                                                -5.133333333333333,
                                                0
                                            ],
                                            [
                                                -3.9333333333333322,
                                                -1.7000000000000075
                                            ],
                                            [
                                                -2.200000000000003,
                                                -3.2666666666666657
                                            ],
                                            [
                                                -0.1999999999999981,
                                                -4.599999999999999
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.13333333333333522,
                                                -3.066666666666663
                                            ],
                                            [
                                                -1.3333333333333333,
                                                -2
                                            ],
                                            [
                                                -2.200000000000003,
                                                -0.9333333333333277
                                            ],
                                            [
                                                -4.2,
                                                0
                                            ],
                                            [
                                                -2.199999999999998,
                                                1.7999999999999972
                                            ],
                                            [
                                                0,
                                                2.5333333333333314
                                            ],
                                            [
                                                1.5,
                                                1.466666666666664
                                            ],
                                            [
                                                2.7000000000000006,
                                                0.9000000000000009
                                            ],
                                            [
                                                2.933333333333337,
                                                0.6000000000000038
                                            ],
                                            [
                                                2.633333333333335,
                                                0.9666666666666686
                                            ],
                                            [
                                                2.133333333333335,
                                                1.5666666666666629
                                            ],
                                            [
                                                1.2000000000000028,
                                                2.4666666666666663
                                            ],
                                            [
                                                0,
                                                4.400000000000001
                                            ],
                                            [
                                                -2.299999999999997,
                                                3.3000000000000003
                                            ],
                                            [
                                                -4.033333333333331,
                                                1.7666666666666666
                                            ],
                                            [
                                                -5.733333333333334,
                                                0
                                            ],
                                            [
                                                -4.133333333333333,
                                                -2
                                            ],
                                            [
                                                -2.1999999999999997,
                                                -3.5666666666666664
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.13333333333333405,
                                                4.9333333333333345
                                            ],
                                            [
                                                2.900000000000001,
                                                2.6999999999999993
                                            ],
                                            [
                                                4.466666666666669,
                                                0
                                            ],
                                            [
                                                2.4333333333333322,
                                                -2.0333333333333337
                                            ],
                                            [
                                                0,
                                                -2.7999999999999994
                                            ],
                                            [
                                                -1.3999999999999961,
                                                -1.5
                                            ],
                                            [
                                                -2.2666666666666657,
                                                -0.7666666666666657
                                            ],
                                            [
                                                -3.866666666666667,
                                                -0.8666666666666695
                                            ],
                                            [
                                                -3.1000000000000014,
                                                -1.1666666666666667
                                            ],
                                            [
                                                -2.1666666666666665,
                                                -1.6333333333333353
                                            ],
                                            [
                                                -1.1333333333333335,
                                                -2.3333333333333335
                                            ],
                                            [
                                                0,
                                                -4.066666666666667
                                            ],
                                            [
                                                2.1,
                                                -3.0999999999999943
                                            ],
                                            [
                                                3.7999999999999994,
                                                -1.7000000000000075
                                            ],
                                            [
                                                5.266666666666668,
                                                0
                                            ],
                                            [
                                                3.9333333333333322,
                                                1.6999999999999982
                                            ],
                                            [
                                                2.199999999999998,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                58.3,
                                                -52.1
                                            ],
                                            [
                                                46.6,
                                                -50.7
                                            ],
                                            [
                                                44.4,
                                                -58.3
                                            ],
                                            [
                                                39.1,
                                                -62.7
                                            ],
                                            [
                                                31.5,
                                                -64.1
                                            ],
                                            [
                                                21.9,
                                                -61.4
                                            ],
                                            [
                                                18.6,
                                                -54.3
                                            ],
                                            [
                                                20.85,
                                                -48.3
                                            ],
                                            [
                                                27.15,
                                                -44.75
                                            ],
                                            [
                                                36.8,
                                                -42.2
                                            ],
                                            [
                                                45.15,
                                                -39.85
                                            ],
                                            [
                                                52.3,
                                                -36.05
                                            ],
                                            [
                                                57.3,
                                                -30
                                            ],
                                            [
                                                59.1,
                                                -20.8
                                            ],
                                            [
                                                55.65,
                                                -9.25
                                            ],
                                            [
                                                46.15,
                                                -1.65
                                            ],
                                            [
                                                32,
                                                1
                                            ],
                                            [
                                                17.2,
                                                -2
                                            ],
                                            [
                                                7.7,
                                                -10.35
                                            ],
                                            [
                                                4.2,
                                                -22.8
                                            ],
                                            [
                                                15.9,
                                                -24.3
                                            ],
                                            [
                                                20.45,
                                                -12.85
                                            ],
                                            [
                                                32.4,
                                                -8.8
                                            ],
                                            [
                                                42.75,
                                                -11.85
                                            ],
                                            [
                                                46.4,
                                                -20
                                            ],
                                            [
                                                44.3,
                                                -26.45
                                            ],
                                            [
                                                38.8,
                                                -29.85
                                            ],
                                            [
                                                31.3,
                                                -31.9
                                            ],
                                            [
                                                20.85,
                                                -34.95
                                            ],
                                            [
                                                12.95,
                                                -39.15
                                            ],
                                            [
                                                8,
                                                -45.1
                                            ],
                                            [
                                                6.3,
                                                -53.4
                                            ],
                                            [
                                                9.45,
                                                -64.15
                                            ],
                                            [
                                                18.3,
                                                -71.35
                                            ],
                                            [
                                                31.7,
                                                -73.9
                                            ],
                                            [
                                                45.5,
                                                -71.35
                                            ],
                                            [
                                                54.7,
                                                -63.9
                                            ],
                                            [
                                                58.3,
                                                -52.1
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "1",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 43.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.1,
                                                2.866666666666665
                                            ],
                                            [
                                                -0.8000000000000019,
                                                4.733333333333339
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.066666666666666,
                                                0
                                            ],
                                            [
                                                3.099999999999999,
                                                -2.866666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                32.2,
                                                0
                                            ],
                                            [
                                                20.6,
                                                0
                                            ],
                                            [
                                                20.6,
                                                -48.8
                                            ],
                                            [
                                                3.5,
                                                -48.8
                                            ],
                                            [
                                                3.5,
                                                -57.2
                                            ],
                                            [
                                                5.5,
                                                -57.2
                                            ],
                                            [
                                                17.75,
                                                -61.5
                                            ],
                                            [
                                                23.6,
                                                -72.9
                                            ],
                                            [
                                                32.2,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "9",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 63,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.633333333333335,
                                                1.6333333333333335
                                            ],
                                            [
                                                2.233333333333333,
                                                3.1
                                            ],
                                            [
                                                0.5333333333333332,
                                                4.133333333333333
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.366666666666667,
                                                -2.1666666666666665
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                2.4333333333333336
                                            ],
                                            [
                                                -1.0333333333333314,
                                                4.166666666666667
                                            ],
                                            [
                                                0.2666666666666657,
                                                5.200000000000003
                                            ],
                                            [
                                                3.4333333333333322,
                                                -1.8666666666666647
                                            ],
                                            [
                                                4.333333333333336,
                                                0
                                            ],
                                            [
                                                3.7000000000000006,
                                                1.9333333333333325
                                            ],
                                            [
                                                2,
                                                3.400000000000001
                                            ],
                                            [
                                                0,
                                                4.533333333333336
                                            ],
                                            [
                                                -2.166666666666667,
                                                3.633333333333335
                                            ],
                                            [
                                                -3.9,
                                                2.066666666666663
                                            ],
                                            [
                                                -5.0666666666666655,
                                                0
                                            ],
                                            [
                                                -4.233333333333334,
                                                -3.1666666666666665
                                            ],
                                            [
                                                -2.0333333333333363,
                                                -5.76666666666667
                                            ],
                                            [
                                                0,
                                                -7.800000000000002
                                            ],
                                            [
                                                1.1666666666666667,
                                                -4.433333333333333
                                            ],
                                            [
                                                2.400000000000001,
                                                -3.266666666666667
                                            ],
                                            [
                                                3.6666666666666665,
                                                -1.7666666666666666
                                            ],
                                            [
                                                5.000000000000003,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -4.733333333333332,
                                                0
                                            ],
                                            [
                                                -3.633333333333333,
                                                -1.6333333333333335
                                            ],
                                            [
                                                -2.233333333333333,
                                                -3.099999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.40000000000000097,
                                                3.666666666666668
                                            ],
                                            [
                                                2.366666666666665,
                                                2.1666666666666665
                                            ],
                                            [
                                                4.800000000000002,
                                                0
                                            ],
                                            [
                                                2.6666666666666665,
                                                -2.4333333333333322
                                            ],
                                            [
                                                1.0333333333333314,
                                                -4.166666666666667
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.8666666666666694
                                            ],
                                            [
                                                -3.4333333333333322,
                                                1.8666666666666671
                                            ],
                                            [
                                                -4.8,
                                                0
                                            ],
                                            [
                                                -3.6999999999999993,
                                                -1.9333333333333347
                                            ],
                                            [
                                                -2.0000000000000004,
                                                -3.3999999999999964
                                            ],
                                            [
                                                0,
                                                -4.799999999999997
                                            ],
                                            [
                                                2.1666666666666665,
                                                -3.633333333333335
                                            ],
                                            [
                                                3.900000000000001,
                                                -2.066666666666672
                                            ],
                                            [
                                                6.600000000000001,
                                                0
                                            ],
                                            [
                                                4.23333333333333,
                                                3.1666666666666665
                                            ],
                                            [
                                                2.0333333333333314,
                                                5.766666666666666
                                            ],
                                            [
                                                0,
                                                5.333333333333333
                                            ],
                                            [
                                                -1.1666666666666667,
                                                4.433333333333334
                                            ],
                                            [
                                                -2.3999999999999964,
                                                3.266666666666666
                                            ],
                                            [
                                                -3.6666666666666665,
                                                1.7666666666666666
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                29.2,
                                                1
                                            ],
                                            [
                                                16.65,
                                                -1.45
                                            ],
                                            [
                                                7.85,
                                                -8.55
                                            ],
                                            [
                                                3.7,
                                                -19.4
                                            ],
                                            [
                                                14.7,
                                                -21.1
                                            ],
                                            [
                                                18.85,
                                                -12.35
                                            ],
                                            [
                                                29,
                                                -9.1
                                            ],
                                            [
                                                40.2,
                                                -12.75
                                            ],
                                            [
                                                45.75,
                                                -22.65
                                            ],
                                            [
                                                46.9,
                                                -36.7
                                            ],
                                            [
                                                39.85,
                                                -29.6
                                            ],
                                            [
                                                28.2,
                                                -26.8
                                            ],
                                            [
                                                15.45,
                                                -29.7
                                            ],
                                            [
                                                6.9,
                                                -37.7
                                            ],
                                            [
                                                3.9,
                                                -49.6
                                            ],
                                            [
                                                7.15,
                                                -62.25
                                            ],
                                            [
                                                16.25,
                                                -70.8
                                            ],
                                            [
                                                29.7,
                                                -73.9
                                            ],
                                            [
                                                45.95,
                                                -69.15
                                            ],
                                            [
                                                55.35,
                                                -55.75
                                            ],
                                            [
                                                58.4,
                                                -35.4
                                            ],
                                            [
                                                56.65,
                                                -20.75
                                            ],
                                            [
                                                51.3,
                                                -9.2
                                            ],
                                            [
                                                42.2,
                                                -1.65
                                            ],
                                            [
                                                29.2,
                                                1
                                            ]
                                        ]
                                    }
                                }
                            },
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.6666666666666665,
                                                2.599999999999999
                                            ],
                                            [
                                                0,
                                                4.1333333333333355
                                            ],
                                            [
                                                2.633333333333335,
                                                2.5333333333333314
                                            ],
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                2.599999999999999,
                                                -2.5333333333333314
                                            ],
                                            [
                                                0,
                                                -4.200000000000003
                                            ],
                                            [
                                                -2.633333333333333,
                                                -2.4333333333333322
                                            ],
                                            [
                                                -4.266666666666666,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                4.333333333333333,
                                                0
                                            ],
                                            [
                                                2.6666666666666665,
                                                -2.599999999999999
                                            ],
                                            [
                                                0,
                                                -4.1333333333333355
                                            ],
                                            [
                                                -2.6333333333333306,
                                                -2.5333333333333314
                                            ],
                                            [
                                                -4.400000000000001,
                                                0
                                            ],
                                            [
                                                -2.6000000000000014,
                                                2.5333333333333314
                                            ],
                                            [
                                                0,
                                                4.400000000000001
                                            ],
                                            [
                                                2.633333333333335,
                                                2.4333333333333322
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                30,
                                                -36
                                            ],
                                            [
                                                40.5,
                                                -39.9
                                            ],
                                            [
                                                44.5,
                                                -50
                                            ],
                                            [
                                                40.55,
                                                -60
                                            ],
                                            [
                                                30.1,
                                                -63.8
                                            ],
                                            [
                                                19.6,
                                                -60
                                            ],
                                            [
                                                15.7,
                                                -49.9
                                            ],
                                            [
                                                19.65,
                                                -39.65
                                            ],
                                            [
                                                30,
                                                -36
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "/",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 44.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                13.9,
                                                0
                                            ],
                                            [
                                                2.8,
                                                0
                                            ],
                                            [
                                                30.5,
                                                -72.9
                                            ],
                                            [
                                                41.6,
                                                -72.9
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "m",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 95.8,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.9333333333333322,
                                                1.5666666666666675
                                            ],
                                            [
                                                -3.3999999999999986,
                                                0
                                            ],
                                            [
                                                -3,
                                                -1.8666666666666696
                                            ],
                                            [
                                                -1.466666666666664,
                                                -3.7333333333333343
                                            ],
                                            [
                                                -3.2666666666666657,
                                                1.9333333333333371
                                            ],
                                            [
                                                -3.866666666666665,
                                                0
                                            ],
                                            [
                                                -3.266666666666661,
                                                -3.5
                                            ],
                                            [
                                                0,
                                                -5.86666666666667
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6999999999999982,
                                                1.9666666666666686
                                            ],
                                            [
                                                3.3333333333333335,
                                                0
                                            ],
                                            [
                                                2.066666666666663,
                                                -1.1666666666666667
                                            ],
                                            [
                                                1.1333333333333353,
                                                -2.199999999999998
                                            ],
                                            [
                                                0,
                                                -3.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.6333333333333353,
                                                2.2333333333333343
                                            ],
                                            [
                                                3.5333333333333337,
                                                0
                                            ],
                                            [
                                                2,
                                                -1.2333333333333296
                                            ],
                                            [
                                                1.1000000000000014,
                                                -2.1666666666666665
                                            ],
                                            [
                                                0,
                                                -2.7333333333333343
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.9333333333333325,
                                                -3.3333333333333335
                                            ],
                                            [
                                                2.933333333333335,
                                                -1.5666666666666675
                                            ],
                                            [
                                                3.8666666666666694,
                                                0
                                            ],
                                            [
                                                3,
                                                1.8666666666666647
                                            ],
                                            [
                                                1.7333333333333343,
                                                -3.599999999999999
                                            ],
                                            [
                                                3.2666666666666657,
                                                -1.9333333333333325
                                            ],
                                            [
                                                6.066666666666673,
                                                0
                                            ],
                                            [
                                                3.2666666666666706,
                                                3.5
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.599999999999999
                                            ],
                                            [
                                                -1.6999999999999982,
                                                -1.966666666666664
                                            ],
                                            [
                                                -2.6000000000000036,
                                                0
                                            ],
                                            [
                                                -2.0666666666666678,
                                                1.1666666666666667
                                            ],
                                            [
                                                -1.1333333333333304,
                                                2.199999999999998
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.5333333333333363
                                            ],
                                            [
                                                -1.6333333333333304,
                                                -2.2333333333333294
                                            ],
                                            [
                                                -2.6666666666666665,
                                                0
                                            ],
                                            [
                                                -2,
                                                1.2333333333333343
                                            ],
                                            [
                                                -1.099999999999999,
                                                2.1666666666666665
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -56.6
                                            ],
                                            [
                                                17.3,
                                                -56.6
                                            ],
                                            [
                                                18.1,
                                                -47.9
                                            ],
                                            [
                                                25.4,
                                                -55.25
                                            ],
                                            [
                                                34.9,
                                                -57.6
                                            ],
                                            [
                                                45.2,
                                                -54.8
                                            ],
                                            [
                                                51.9,
                                                -46.4
                                            ],
                                            [
                                                59.4,
                                                -54.7
                                            ],
                                            [
                                                70.1,
                                                -57.6
                                            ],
                                            [
                                                84.1,
                                                -52.35
                                            ],
                                            [
                                                89,
                                                -38.3
                                            ],
                                            [
                                                89,
                                                0
                                            ],
                                            [
                                                77.3,
                                                0
                                            ],
                                            [
                                                77.3,
                                                -36
                                            ],
                                            [
                                                74.75,
                                                -44.35
                                            ],
                                            [
                                                67.2,
                                                -47.3
                                            ],
                                            [
                                                60.2,
                                                -45.55
                                            ],
                                            [
                                                55.4,
                                                -40.5
                                            ],
                                            [
                                                53.7,
                                                -32.6
                                            ],
                                            [
                                                53.7,
                                                0
                                            ],
                                            [
                                                42,
                                                0
                                            ],
                                            [
                                                42,
                                                -35.3
                                            ],
                                            [
                                                39.55,
                                                -43.95
                                            ],
                                            [
                                                31.8,
                                                -47.3
                                            ],
                                            [
                                                24.8,
                                                -45.45
                                            ],
                                            [
                                                20.15,
                                                -40.35
                                            ],
                                            [
                                                18.5,
                                                -33
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            "ch": "h",
            "fFamily": "BDO Grotesk",
            "size": 11,
            "style": "Medium",
            "w": 62.5,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "nm": "",
                        "it": [
                            {
                                "ty": "sh",
                                "nm": "",
                                "d": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "c": false,
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.900000000000001,
                                                1.400000000000001
                                            ],
                                            [
                                                -3.799999999999997,
                                                0
                                            ],
                                            [
                                                -3.599999999999999,
                                                -3.2666666666666657
                                            ],
                                            [
                                                0,
                                                -6.599999999999999
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.900000000000001,
                                                1.9333333333333325
                                            ],
                                            [
                                                3.799999999999997,
                                                0
                                            ],
                                            [
                                                2.1666666666666665,
                                                -1.099999999999999
                                            ],
                                            [
                                                1.2666666666666657,
                                                -2.0666666666666678
                                            ],
                                            [
                                                0.06666666666666761,
                                                -2.866666666666665
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.2666666666666657,
                                                -3.0666666666666678
                                            ],
                                            [
                                                2.900000000000001,
                                                -1.3999999999999961
                                            ],
                                            [
                                                5.733333333333334,
                                                0
                                            ],
                                            [
                                                3.6000000000000036,
                                                3.2666666666666657
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -3.3333333333333335
                                            ],
                                            [
                                                -1.900000000000001,
                                                -1.9333333333333325
                                            ],
                                            [
                                                -2.5333333333333363,
                                                0
                                            ],
                                            [
                                                -2.1666666666666665,
                                                1.099999999999999
                                            ],
                                            [
                                                -1.2666666666666657,
                                                2.0666666666666678
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                18.5,
                                                0
                                            ],
                                            [
                                                6.8,
                                                0
                                            ],
                                            [
                                                6.8,
                                                -79
                                            ],
                                            [
                                                18.5,
                                                -79
                                            ],
                                            [
                                                18.5,
                                                -49
                                            ],
                                            [
                                                26.25,
                                                -55.7
                                            ],
                                            [
                                                36.3,
                                                -57.8
                                            ],
                                            [
                                                50.3,
                                                -52.9
                                            ],
                                            [
                                                55.7,
                                                -38.1
                                            ],
                                            [
                                                55.7,
                                                0
                                            ],
                                            [
                                                44.1,
                                                0
                                            ],
                                            [
                                                44.1,
                                                -36.7
                                            ],
                                            [
                                                41.25,
                                                -44.6
                                            ],
                                            [
                                                32.7,
                                                -47.5
                                            ],
                                            [
                                                25.65,
                                                -45.85
                                            ],
                                            [
                                                20.5,
                                                -41.1
                                            ],
                                            [
                                                18.5,
                                                -33.7
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "assets": [
        {
            "nm": "Animation",
            "id": "1",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Isometric",
                    "sr": 1,
                    "st": 3,
                    "op": 4842,
                    "ip": 3,
                    "ln": "792",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "2",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "AI Chat ",
                    "sr": 1,
                    "st": 120,
                    "op": 4959,
                    "ip": 120,
                    "ln": "791",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                736
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "14",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Dots",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "790",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "21",
                    "ind": 3
                },
                {
                    "ty": 0,
                    "nm": "Webpage",
                    "sr": 1,
                    "st": 120,
                    "op": 4959,
                    "ip": 120,
                    "ln": "789",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                726
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 764,
                    "h": 732,
                    "refId": "22",
                    "ind": 4
                }
            ]
        },
        {
            "nm": "Isometric",
            "id": "2",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Cube - 2d",
                    "sr": 1,
                    "st": 389,
                    "op": 519,
                    "ip": 389,
                    "ln": "1145",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                540,
                                540
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                35,
                                35
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                266
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1080,
                    "h": 1080,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Cube - 2d",
                    "sr": 1,
                    "st": 259,
                    "op": 389,
                    "ip": 259,
                    "ln": "1144",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                540,
                                540
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                35,
                                35
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                266
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1080,
                    "h": 1080,
                    "refId": "3",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Cube - 2d",
                    "sr": 1,
                    "st": 130,
                    "op": 260,
                    "ip": 130,
                    "ln": "1143",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                540,
                                540
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                35,
                                35
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                266
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1080,
                    "h": 1080,
                    "refId": "3",
                    "ind": 3
                },
                {
                    "ty": 0,
                    "nm": "Cube - 2d",
                    "sr": 1,
                    "st": 0,
                    "op": 130,
                    "ip": 0,
                    "ln": "1140",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                540,
                                540
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                35,
                                35
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                266
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 1080,
                    "h": 1080,
                    "refId": "3",
                    "ind": 4
                },
                {
                    "ty": 0,
                    "nm": "2R.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 38800,
                    "ip": 0,
                    "ln": "751",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                55.5,
                                66
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 63
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.333
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 135.999
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 198.998
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.333
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 259.998
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 322.997
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.333
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 395.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 458.996
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.333
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 517.996
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 580.995
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0.333
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        156.59,
                                        141.318
                                    ],
                                    "t": 653.995
                                },
                                {
                                    "s": [
                                        156.59,
                                        164.444
                                    ],
                                    "t": 716.994
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 111,
                    "h": 132,
                    "refId": "12",
                    "ind": 5
                },
                {
                    "ty": 0,
                    "nm": "1R.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 38800,
                    "ip": 0,
                    "ln": "750",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                40,
                                44
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 0
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 61
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 135.999
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 196.998
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 259.998
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 320.997
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 395.997
                                },
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 456.996
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 517.996
                                },
                                {
                                    "o": {
                                        "x": 0.333,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 0.667,
                                        "y": 1
                                    },
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 578.995
                                },
                                {
                                    "o": {
                                        "x": 0,
                                        "y": 0
                                    },
                                    "i": {
                                        "x": 1,
                                        "y": 1
                                    },
                                    "s": [
                                        590.857,
                                        174.857
                                    ],
                                    "t": 653.995
                                },
                                {
                                    "s": [
                                        588.857,
                                        149.571
                                    ],
                                    "t": 714.994
                                }
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 80,
                    "h": 88,
                    "refId": "13",
                    "ind": 6
                }
            ]
        },
        {
            "nm": "Cube - 2d",
            "id": "3",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 222222222 :M",
                    "sr": 1,
                    "st": 0,
                    "op": 132,
                    "ip": 0,
                    "ln": "1128",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                505.362,
                                531.724
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                505.362,
                                531.724
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222222",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222222",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22222",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 222",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.666,
                                                                                                136.383
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.595,
                                                                                                -25.338
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.765,
                                                                                                212.109
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.459,
                                                                                                147.252
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.765,
                                                                                                212.109
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.459,
                                                                                                147.252
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.666,
                                                                                                136.383
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.595,
                                                                                                -25.338
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            643.114,
                                                            716.874
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            643.114,
                                                            716.874
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    605.85,
                                                    595.522
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    605.85,
                                                    595.522
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            643.114,
                                            716.874
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            643.114,
                                            716.874
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222223",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222223",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22223",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 223",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.868,
                                                                                                134.454
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                21.101,
                                                                                                274.841
                                                                                            ],
                                                                                            [
                                                                                                173.308,
                                                                                                287.065
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.967,
                                                                                                210.18
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                97.226,
                                                                                                254.771
                                                                                            ],
                                                                                            [
                                                                                                234.245,
                                                                                                264.808
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.967,
                                                                                                210.18
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                97.226,
                                                                                                254.771
                                                                                            ],
                                                                                            [
                                                                                                234.245,
                                                                                                264.808
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.868,
                                                                                                134.454
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                21.101,
                                                                                                274.841
                                                                                            ],
                                                                                            [
                                                                                                173.308,
                                                                                                287.065
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            684.246,
                                                            773.821
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            684.246,
                                                            773.821
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    625.863,
                                                    748.69
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    625.863,
                                                    748.69
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            684.246,
                                            773.821
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            684.246,
                                            773.821
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222229",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222229",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22229",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 229",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.482,
                                                                                                136.122
                                                                                            ],
                                                                                            [
                                                                                                201.687,
                                                                                                68.437
                                                                                            ],
                                                                                            [
                                                                                                186.769,
                                                                                                -79.881
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.581,
                                                                                                211.848
                                                                                            ],
                                                                                            [
                                                                                                219.758,
                                                                                                69.58
                                                                                            ],
                                                                                            [
                                                                                                187.769,
                                                                                                -3.881
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.581,
                                                                                                211.848
                                                                                            ],
                                                                                            [
                                                                                                219.758,
                                                                                                69.58
                                                                                            ],
                                                                                            [
                                                                                                187.769,
                                                                                                -3.881
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.482,
                                                                                                136.122
                                                                                            ],
                                                                                            [
                                                                                                201.687,
                                                                                                68.437
                                                                                            ],
                                                                                            [
                                                                                                186.769,
                                                                                                -79.881
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            730.181,
                                                            643.984
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            730.181,
                                                            643.984
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    710.213,
                                                    568.121
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    710.213,
                                                    568.121
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            730.181,
                                            643.984
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            730.181,
                                            643.984
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333333",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333333",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33333",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 333",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                236.486,
                                                                                                16.798
                                                                                            ],
                                                                                            [
                                                                                                225.209,
                                                                                                -125.607
                                                                                            ],
                                                                                            [
                                                                                                257.019,
                                                                                                -163.654
                                                                                            ],
                                                                                            [
                                                                                                268.271,
                                                                                                -33.606
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                239.486,
                                                                                                -50.702
                                                                                            ],
                                                                                            [
                                                                                                205.959,
                                                                                                -136.357
                                                                                            ],
                                                                                            [
                                                                                                225.724,
                                                                                                -261.14
                                                                                            ],
                                                                                            [
                                                                                                255.875,
                                                                                                -173.15
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                239.486,
                                                                                                -50.702
                                                                                            ],
                                                                                            [
                                                                                                205.959,
                                                                                                -136.357
                                                                                            ],
                                                                                            [
                                                                                                225.724,
                                                                                                -261.14
                                                                                            ],
                                                                                            [
                                                                                                255.875,
                                                                                                -173.15
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                236.486,
                                                                                                16.798
                                                                                            ],
                                                                                            [
                                                                                                225.209,
                                                                                                -125.607
                                                                                            ],
                                                                                            [
                                                                                                257.019,
                                                                                                -163.654
                                                                                            ],
                                                                                            [
                                                                                                268.271,
                                                                                                -33.606
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            770.917,
                                                            384.079
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            770.917,
                                                            384.079
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    786.74,
                                                    466.572
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    786.74,
                                                    466.572
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            770.917,
                                            384.079
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            770.917,
                                            384.079
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 11111111111111119",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 111111119",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 11119",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 119",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                214.225,
                                                                                                -277.331
                                                                                            ],
                                                                                            [
                                                                                                60.096,
                                                                                                -264.893
                                                                                            ],
                                                                                            [
                                                                                                7.279,
                                                                                                -231.26
                                                                                            ],
                                                                                            [
                                                                                                169.426,
                                                                                                -240.928
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                166.254,
                                                                                                -232.889
                                                                                            ],
                                                                                            [
                                                                                                10.607,
                                                                                                -223.8
                                                                                            ],
                                                                                            [
                                                                                                -21.749,
                                                                                                -87.333
                                                                                            ],
                                                                                            [
                                                                                                140.413,
                                                                                                -88.108
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                166.254,
                                                                                                -232.889
                                                                                            ],
                                                                                            [
                                                                                                10.607,
                                                                                                -223.8
                                                                                            ],
                                                                                            [
                                                                                                -21.749,
                                                                                                -87.333
                                                                                            ],
                                                                                            [
                                                                                                140.413,
                                                                                                -88.108
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                214.225,
                                                                                                -277.331
                                                                                            ],
                                                                                            [
                                                                                                60.096,
                                                                                                -264.893
                                                                                            ],
                                                                                            [
                                                                                                7.279,
                                                                                                -231.26
                                                                                            ],
                                                                                            [
                                                                                                169.426,
                                                                                                -240.928
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            1,
                                                                            1,
                                                                            1
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            612.252,
                                                            379.889
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            612.252,
                                                            379.889
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    650.752,
                                                    285.704
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    650.752,
                                                    285.704
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            612.252,
                                            379.889
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            612.252,
                                            379.889
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 11111111111111118",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 111111118",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 11118",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 118",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                210.773,
                                                                                                -274.703
                                                                                            ],
                                                                                            [
                                                                                                59.097,
                                                                                                -263.065
                                                                                            ],
                                                                                            [
                                                                                                108.308,
                                                                                                -293.696
                                                                                            ],
                                                                                            [
                                                                                                246.137,
                                                                                                -304.045
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                162.801,
                                                                                                -230.261
                                                                                            ],
                                                                                            [
                                                                                                9.608,
                                                                                                -221.971
                                                                                            ],
                                                                                            [
                                                                                                39.261,
                                                                                                -350.176
                                                                                            ],
                                                                                            [
                                                                                                189.719,
                                                                                                -363.492
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                162.801,
                                                                                                -230.261
                                                                                            ],
                                                                                            [
                                                                                                9.608,
                                                                                                -221.971
                                                                                            ],
                                                                                            [
                                                                                                39.261,
                                                                                                -350.176
                                                                                            ],
                                                                                            [
                                                                                                189.719,
                                                                                                -363.492
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                210.773,
                                                                                                -274.703
                                                                                            ],
                                                                                            [
                                                                                                59.097,
                                                                                                -263.065
                                                                                            ],
                                                                                            [
                                                                                                108.308,
                                                                                                -293.696
                                                                                            ],
                                                                                            [
                                                                                                246.137,
                                                                                                -304.045
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            1,
                                                                            1,
                                                                            1
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            639.664,
                                                            247.269
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            639.664,
                                                            247.269
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    692.617,
                                                    256.445
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    692.617,
                                                    256.445
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            639.664,
                                            247.269
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            639.664,
                                            247.269
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222220",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222220",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22220",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 220",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                119.167,
                                                                                                -198.676
                                                                                            ],
                                                                                            [
                                                                                                -49.147,
                                                                                                -190.446
                                                                                            ],
                                                                                            [
                                                                                                11.974,
                                                                                                -233.57
                                                                                            ],
                                                                                            [
                                                                                                172.133,
                                                                                                -243.281
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.9,
                                                                                                70.186
                                                                                            ],
                                                                                            [
                                                                                                -57.793,
                                                                                                67.228
                                                                                            ],
                                                                                            [
                                                                                                -21.631,
                                                                                                -87.84
                                                                                            ],
                                                                                            [
                                                                                                143.12,
                                                                                                -90.46
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.9,
                                                                                                70.186
                                                                                            ],
                                                                                            [
                                                                                                -57.793,
                                                                                                67.228
                                                                                            ],
                                                                                            [
                                                                                                -21.631,
                                                                                                -87.84
                                                                                            ],
                                                                                            [
                                                                                                143.12,
                                                                                                -90.46
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                119.167,
                                                                                                -198.676
                                                                                            ],
                                                                                            [
                                                                                                -49.147,
                                                                                                -190.446
                                                                                            ],
                                                                                            [
                                                                                                11.974,
                                                                                                -233.57
                                                                                            ],
                                                                                            [
                                                                                                172.133,
                                                                                                -243.281
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            1,
                                                                            1,
                                                                            1
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            582.664,
                                                            529.863
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            582.664,
                                                            529.863
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    598.678,
                                                    323.63
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    598.678,
                                                    323.63
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            582.664,
                                            529.863
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            582.664,
                                            529.863
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222221",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222221",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22221",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 221",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                118.977,
                                                                                                -198.952
                                                                                            ],
                                                                                            [
                                                                                                -49.918,
                                                                                                -190.088
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.71,
                                                                                                69.91
                                                                                            ],
                                                                                            [
                                                                                                -58.068,
                                                                                                67.292
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.71,
                                                                                                69.91
                                                                                            ],
                                                                                            [
                                                                                                -58.068,
                                                                                                67.292
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                118.977,
                                                                                                -198.952
                                                                                            ],
                                                                                            [
                                                                                                -49.918,
                                                                                                -190.088
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            591.267,
                                                            647.751
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            591.267,
                                                            647.751
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    584.411,
                                                    428.601
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    584.411,
                                                    428.601
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            591.267,
                                            647.751
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            591.267,
                                            647.751
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222225",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222225",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22225",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 225",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.666,
                                                                                                136.383
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.595,
                                                                                                -25.338
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.765,
                                                                                                212.109
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.459,
                                                                                                147.252
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.765,
                                                                                                212.109
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                5.462,
                                                                                                141.64
                                                                                            ],
                                                                                            [
                                                                                                160.459,
                                                                                                147.252
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.666,
                                                                                                136.383
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                -24.966,
                                                                                                -23.847
                                                                                            ],
                                                                                            [
                                                                                                138.595,
                                                                                                -25.338
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            643.114,
                                                            716.874
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            643.114,
                                                            716.874
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    605.85,
                                                    595.522
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    605.85,
                                                    595.522
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            643.114,
                                            716.874
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            643.114,
                                            716.874
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222226",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222226",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22226",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 226",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.868,
                                                                                                134.454
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                21.101,
                                                                                                274.841
                                                                                            ],
                                                                                            [
                                                                                                173.308,
                                                                                                287.065
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.967,
                                                                                                210.18
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                97.226,
                                                                                                254.771
                                                                                            ],
                                                                                            [
                                                                                                234.245,
                                                                                                264.808
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                200.967,
                                                                                                210.18
                                                                                            ],
                                                                                            [
                                                                                                54.246,
                                                                                                202.834
                                                                                            ],
                                                                                            [
                                                                                                97.226,
                                                                                                254.771
                                                                                            ],
                                                                                            [
                                                                                                234.245,
                                                                                                264.808
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.868,
                                                                                                134.454
                                                                                            ],
                                                                                            [
                                                                                                -1.581,
                                                                                                130.315
                                                                                            ],
                                                                                            [
                                                                                                21.101,
                                                                                                274.841
                                                                                            ],
                                                                                            [
                                                                                                173.308,
                                                                                                287.065
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            684.246,
                                                            773.821
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            684.246,
                                                            773.821
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    625.863,
                                                    748.69
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    625.863,
                                                    748.69
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            684.246,
                                            773.821
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            684.246,
                                            773.821
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222224",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222224",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22224",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 224",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                118.977,
                                                                                                -198.952
                                                                                            ],
                                                                                            [
                                                                                                169.59,
                                                                                                -240.972
                                                                                            ],
                                                                                            [
                                                                                                186.769,
                                                                                                -79.881
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.71,
                                                                                                69.91
                                                                                            ],
                                                                                            [
                                                                                                140.577,
                                                                                                -88.151
                                                                                            ],
                                                                                            [
                                                                                                187.769,
                                                                                                -3.881
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                111.71,
                                                                                                69.91
                                                                                            ],
                                                                                            [
                                                                                                140.577,
                                                                                                -88.151
                                                                                            ],
                                                                                            [
                                                                                                187.769,
                                                                                                -3.881
                                                                                            ],
                                                                                            [
                                                                                                160.603,
                                                                                                148.21
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                118.977,
                                                                                                -198.952
                                                                                            ],
                                                                                            [
                                                                                                169.59,
                                                                                                -240.972
                                                                                            ],
                                                                                            [
                                                                                                186.769,
                                                                                                -79.881
                                                                                            ],
                                                                                            [
                                                                                                138.739,
                                                                                                -24.381
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            689.739,
                                                            570.029
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            689.739,
                                                            570.029
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    692.873,
                                                    407.323
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    692.873,
                                                    407.323
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            689.739,
                                            570.029
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            689.739,
                                            570.029
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222227",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222227",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22227",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 227",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                212.842,
                                                                                                -278.516
                                                                                            ],
                                                                                            [
                                                                                                225.297,
                                                                                                -124.356
                                                                                            ],
                                                                                            [
                                                                                                185.501,
                                                                                                -76.371
                                                                                            ],
                                                                                            [
                                                                                                169.426,
                                                                                                -240.928
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                164.871,
                                                                                                -234.074
                                                                                            ],
                                                                                            [
                                                                                                206.047,
                                                                                                -135.106
                                                                                            ],
                                                                                            [
                                                                                                186.501,
                                                                                                -0.371
                                                                                            ],
                                                                                            [
                                                                                                140.413,
                                                                                                -88.108
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                164.871,
                                                                                                -234.074
                                                                                            ],
                                                                                            [
                                                                                                206.047,
                                                                                                -135.106
                                                                                            ],
                                                                                            [
                                                                                                186.501,
                                                                                                -0.371
                                                                                            ],
                                                                                            [
                                                                                                140.413,
                                                                                                -88.108
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                212.842,
                                                                                                -278.516
                                                                                            ],
                                                                                            [
                                                                                                225.297,
                                                                                                -124.356
                                                                                            ],
                                                                                            [
                                                                                                185.501,
                                                                                                -76.371
                                                                                            ],
                                                                                            [
                                                                                                169.426,
                                                                                                -240.928
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            713.23,
                                                            422.777
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            713.23,
                                                            422.777
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    737.361,
                                                    362.556
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    737.361,
                                                    362.556
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            713.23,
                                            422.777
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            713.23,
                                            422.777
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 22222222222222228",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 222222228",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 22228",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 228",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                211.657,
                                                                                                -278.516
                                                                                            ],
                                                                                            [
                                                                                                225.297,
                                                                                                -124.356
                                                                                            ],
                                                                                            [
                                                                                                257.107,
                                                                                                -162.403
                                                                                            ],
                                                                                            [
                                                                                                245.705,
                                                                                                -304.086
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                163.686,
                                                                                                -234.074
                                                                                            ],
                                                                                            [
                                                                                                206.047,
                                                                                                -135.106
                                                                                            ],
                                                                                            [
                                                                                                225.812,
                                                                                                -259.888
                                                                                            ],
                                                                                            [
                                                                                                189.287,
                                                                                                -363.533
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                163.686,
                                                                                                -234.074
                                                                                            ],
                                                                                            [
                                                                                                206.047,
                                                                                                -135.106
                                                                                            ],
                                                                                            [
                                                                                                225.812,
                                                                                                -259.888
                                                                                            ],
                                                                                            [
                                                                                                189.287,
                                                                                                -363.533
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                211.657,
                                                                                                -278.516
                                                                                            ],
                                                                                            [
                                                                                                225.297,
                                                                                                -124.356
                                                                                            ],
                                                                                            [
                                                                                                257.107,
                                                                                                -162.403
                                                                                            ],
                                                                                            [
                                                                                                245.705,
                                                                                                -304.086
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            734.749,
                                                            290.681
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            734.749,
                                                            290.681
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    774.382,
                                                    325.779
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    774.382,
                                                    325.779
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            734.749,
                                            290.681
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            734.749,
                                            290.681
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333330",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333330",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33330",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 330",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                238.46,
                                                                                                13.051
                                                                                            ],
                                                                                            [
                                                                                                200.304,
                                                                                                71.597
                                                                                            ],
                                                                                            [
                                                                                                184.662,
                                                                                                -78.817
                                                                                            ],
                                                                                            [
                                                                                                226.608,
                                                                                                -128.861
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                241.46,
                                                                                                -54.449
                                                                                            ],
                                                                                            [
                                                                                                219.153,
                                                                                                72.074
                                                                                            ],
                                                                                            [
                                                                                                185.662,
                                                                                                -2.817
                                                                                            ],
                                                                                            [
                                                                                                207.358,
                                                                                                -139.611
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                241.46,
                                                                                                -54.449
                                                                                            ],
                                                                                            [
                                                                                                219.153,
                                                                                                72.074
                                                                                            ],
                                                                                            [
                                                                                                185.662,
                                                                                                -2.817
                                                                                            ],
                                                                                            [
                                                                                                207.358,
                                                                                                -139.611
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                238.46,
                                                                                                13.051
                                                                                            ],
                                                                                            [
                                                                                                200.304,
                                                                                                71.597
                                                                                            ],
                                                                                            [
                                                                                                184.662,
                                                                                                -78.817
                                                                                            ],
                                                                                            [
                                                                                                226.608,
                                                                                                -128.861
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            753.561,
                                                            506.231
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            753.561,
                                                            506.231
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    751.561,
                                                    511.368
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    751.561,
                                                    511.368
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            753.561,
                                            506.231
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            753.561,
                                            506.231
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333331",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333331",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33331",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 331",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                238.304,
                                                                                                10.397
                                                                                            ],
                                                                                            [
                                                                                                199.992,
                                                                                                68.632
                                                                                            ],
                                                                                            [
                                                                                                215.169,
                                                                                                208.929
                                                                                            ],
                                                                                            [
                                                                                                249.311,
                                                                                                140.525
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                241.304,
                                                                                                -57.103
                                                                                            ],
                                                                                            [
                                                                                                218.064,
                                                                                                69.775
                                                                                            ],
                                                                                            [
                                                                                                250.199,
                                                                                                134.425
                                                                                            ],
                                                                                            [
                                                                                                269.168,
                                                                                                6.739
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                241.304,
                                                                                                -57.103
                                                                                            ],
                                                                                            [
                                                                                                218.064,
                                                                                                69.775
                                                                                            ],
                                                                                            [
                                                                                                250.199,
                                                                                                134.425
                                                                                            ],
                                                                                            [
                                                                                                269.168,
                                                                                                6.739
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                238.304,
                                                                                                10.397
                                                                                            ],
                                                                                            [
                                                                                                199.992,
                                                                                                68.632
                                                                                            ],
                                                                                            [
                                                                                                215.169,
                                                                                                208.929
                                                                                            ],
                                                                                            [
                                                                                                249.311,
                                                                                                140.525
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            783.616,
                                                            578.661
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            783.616,
                                                            578.661
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    764.652,
                                                    649.663
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    764.652,
                                                    649.663
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            783.616,
                                            578.661
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            783.616,
                                            578.661
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333332",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333332",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33332",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 332",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.988,
                                                                                                134.052
                                                                                            ],
                                                                                            [
                                                                                                202.177,
                                                                                                65.042
                                                                                            ],
                                                                                            [
                                                                                                216.574,
                                                                                                204.189
                                                                                            ],
                                                                                            [
                                                                                                174.513,
                                                                                                287.533
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                201.087,
                                                                                                209.778
                                                                                            ],
                                                                                            [
                                                                                                220.249,
                                                                                                66.185
                                                                                            ],
                                                                                            [
                                                                                                251.604,
                                                                                                129.684
                                                                                            ],
                                                                                            [
                                                                                                235.451,
                                                                                                265.276
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                201.087,
                                                                                                209.778
                                                                                            ],
                                                                                            [
                                                                                                220.249,
                                                                                                66.185
                                                                                            ],
                                                                                            [
                                                                                                251.604,
                                                                                                129.684
                                                                                            ],
                                                                                            [
                                                                                                235.451,
                                                                                                265.276
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                156.988,
                                                                                                134.052
                                                                                            ],
                                                                                            [
                                                                                                202.177,
                                                                                                65.042
                                                                                            ],
                                                                                            [
                                                                                                216.574,
                                                                                                204.189
                                                                                            ],
                                                                                            [
                                                                                                174.513,
                                                                                                287.533
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            766.346,
                                                            705.731
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            766.346,
                                                            705.731
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    726.781,
                                                    716.288
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    726.781,
                                                    716.288
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            766.346,
                                            705.731
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            766.346,
                                            705.731
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333334",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333334",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33334",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape Layer 334",
                                                    "it": [
                                                        {
                                                            "ty": "gr",
                                                            "nm": "Shape 1",
                                                            "it": [
                                                                {
                                                                    "ty": "sh",
                                                                    "nm": "Path 1",
                                                                    "d": 1,
                                                                    "ks": {
                                                                        "a": 1,
                                                                        "k": [
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                236.174,
                                                                                                14.145
                                                                                            ],
                                                                                            [
                                                                                                247.923,
                                                                                                142.706
                                                                                            ],
                                                                                            [
                                                                                                277.687,
                                                                                                85.068
                                                                                            ],
                                                                                            [
                                                                                                267.959,
                                                                                                -36.26
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 0
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                239.174,
                                                                                                -53.355
                                                                                            ],
                                                                                            [
                                                                                                267.78,
                                                                                                8.92
                                                                                            ],
                                                                                            [
                                                                                                282.544,
                                                                                                -101.218
                                                                                            ],
                                                                                            [
                                                                                                255.563,
                                                                                                -175.803
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 60
                                                                            },
                                                                            {
                                                                                "o": {
                                                                                    "x": 0.6,
                                                                                    "y": 0
                                                                                },
                                                                                "i": {
                                                                                    "x": 0.4,
                                                                                    "y": 1
                                                                                },
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                239.174,
                                                                                                -53.355
                                                                                            ],
                                                                                            [
                                                                                                267.78,
                                                                                                8.92
                                                                                            ],
                                                                                            [
                                                                                                282.544,
                                                                                                -101.218
                                                                                            ],
                                                                                            [
                                                                                                255.563,
                                                                                                -175.803
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 69.999
                                                                            },
                                                                            {
                                                                                "s": [
                                                                                    {
                                                                                        "c": true,
                                                                                        "i": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "o": [
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ],
                                                                                            [
                                                                                                0,
                                                                                                0
                                                                                            ]
                                                                                        ],
                                                                                        "v": [
                                                                                            [
                                                                                                236.174,
                                                                                                14.145
                                                                                            ],
                                                                                            [
                                                                                                247.923,
                                                                                                142.706
                                                                                            ],
                                                                                            [
                                                                                                277.687,
                                                                                                85.068
                                                                                            ],
                                                                                            [
                                                                                                267.959,
                                                                                                -36.26
                                                                                            ]
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "t": 129.999
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "st",
                                                                    "nm": "Stroke 1",
                                                                    "lc": 1,
                                                                    "lj": 2,
                                                                    "ml": 4,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    },
                                                                    "w": {
                                                                        "a": 0,
                                                                        "k": 5
                                                                    },
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.4039,
                                                                            0.3333,
                                                                            1
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "fl",
                                                                    "nm": "Fill 1",
                                                                    "c": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0.8471,
                                                                            0.8078,
                                                                            0.9765
                                                                        ]
                                                                    },
                                                                    "r": 1,
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                },
                                                                {
                                                                    "ty": "tr",
                                                                    "a": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "s": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            100,
                                                                            100
                                                                        ]
                                                                    },
                                                                    "p": {
                                                                        "a": 0,
                                                                        "k": [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    },
                                                                    "r": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "sa": {
                                                                        "a": 0,
                                                                        "k": 0
                                                                    },
                                                                    "o": {
                                                                        "a": 0,
                                                                        "k": 100
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    540,
                                                                    540
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            800.859,
                                                            456.559
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            800.859,
                                                            456.559
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    796.93,
                                                    593.223
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    796.93,
                                                    593.223
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            800.859,
                                            456.559
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            800.859,
                                            456.559
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 33333333333333335",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 333333335",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 33335",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            110.076,
                                                                            -293.329
                                                                        ],
                                                                        [
                                                                            -50.449,
                                                                            -191.227
                                                                        ],
                                                                        [
                                                                            21.795,
                                                                            277.687
                                                                        ],
                                                                        [
                                                                            66.724,
                                                                            219.241
                                                                        ],
                                                                        [
                                                                            146.647,
                                                                            32.348
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4314,
                                                                    0.2902,
                                                                    0.7882
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    588.099,
                                                    530.679
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    588.099,
                                                    530.679
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            588.099,
                                            530.679
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            588.099,
                                            530.679
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 5",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 5",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 5",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -203.845,
                                                                            -182.626
                                                                        ],
                                                                        [
                                                                            -346.469,
                                                                            -176.148
                                                                        ],
                                                                        [
                                                                            -313.737,
                                                                            -22.182
                                                                        ],
                                                                        [
                                                                            -175.717,
                                                                            -22.182
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    278.907,
                                                    437.596
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    278.907,
                                                    437.596
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            278.907,
                                            437.596
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278.907,
                                            437.596
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 6",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 6",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 6",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -147.623,
                                                                            124.87
                                                                        ],
                                                                        [
                                                                            -281.819,
                                                                            120.783
                                                                        ],
                                                                        [
                                                                            -313.737,
                                                                            -22.182
                                                                        ],
                                                                        [
                                                                            -175.717,
                                                                            -22.182
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    309.32,
                                                    591.344
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    309.32,
                                                    591.344
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            309.32,
                                            591.344
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            309.32,
                                            591.344
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 7",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 7",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 7",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -147.623,
                                                                            124.87
                                                                        ],
                                                                        [
                                                                            -281.819,
                                                                            120.783
                                                                        ],
                                                                        [
                                                                            -252.965,
                                                                            252.98
                                                                        ],
                                                                        [
                                                                            -120.717,
                                                                            263.818
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    338.732,
                                                    732.3
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    338.732,
                                                    732.3
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            338.732,
                                            732.3
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            338.732,
                                            732.3
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 8",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 8",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 8",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -204.512,
                                                                            -182.182
                                                                        ],
                                                                        [
                                                                            -49.918,
                                                                            -190.088
                                                                        ],
                                                                        [
                                                                            -24.966,
                                                                            -23.847
                                                                        ],
                                                                        [
                                                                            -175.717,
                                                                            -22.182
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    425.261,
                                                    433.865
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    425.261,
                                                    433.865
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            425.261,
                                            433.865
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            425.261,
                                            433.865
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 9",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 9",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 9",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -147.432,
                                                                            124.654
                                                                        ],
                                                                        [
                                                                            -1.581,
                                                                            130.315
                                                                        ],
                                                                        [
                                                                            -24.966,
                                                                            -23.847
                                                                        ],
                                                                        [
                                                                            -175.717,
                                                                            -22.182
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    451.351,
                                                    593.234
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    451.351,
                                                    593.234
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            451.351,
                                            593.234
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            451.351,
                                            593.234
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111110",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11110",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 110",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -147.432,
                                                                            124.654
                                                                        ],
                                                                        [
                                                                            -1.581,
                                                                            130.315
                                                                        ],
                                                                        [
                                                                            21.101,
                                                                            274.841
                                                                        ],
                                                                        [
                                                                            -120.555,
                                                                            263.64
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.8471,
                                                                    0.8078,
                                                                    0.9765
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    476.834,
                                                    739.747
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    476.834,
                                                    739.747
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            476.834,
                                            739.747
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            476.834,
                                            739.747
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111111",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11111",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 111",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -204.512,
                                                                            -182.182
                                                                        ],
                                                                        [
                                                                            -346.963,
                                                                            -175.655
                                                                        ],
                                                                        [
                                                                            -253.547,
                                                                            -218.999
                                                                        ],
                                                                        [
                                                                            -124.544,
                                                                            -224.646
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    304.247,
                                                    339.85
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    304.247,
                                                    339.85
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            304.247,
                                            339.85
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            304.247,
                                            339.85
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111112",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11112",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 112",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -206.678,
                                                                            -181.515
                                                                        ],
                                                                        [
                                                                            -52.085,
                                                                            -189.421
                                                                        ],
                                                                        [
                                                                            17.085,
                                                                            -233.682
                                                                        ],
                                                                        [
                                                                            -129.812,
                                                                            -224.059
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    445.203,
                                                    332.402
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    445.203,
                                                    332.402
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            445.203,
                                            332.402
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            445.203,
                                            332.402
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111113",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11113",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 113",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -65.336,
                                                                            -255.985
                                                                        ],
                                                                        [
                                                                            -190.246,
                                                                            -248.01
                                                                        ],
                                                                        [
                                                                            -261.172,
                                                                            -215.874
                                                                        ],
                                                                        [
                                                                            -132.044,
                                                                            -222.646
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    376.746,
                                                    304.07
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    376.746,
                                                    304.07
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            376.746,
                                            304.07
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            376.746,
                                            304.07
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111114",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11114",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 114",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -67.219,
                                                                            -255.964
                                                                        ],
                                                                        [
                                                                            65.152,
                                                                            -265.315
                                                                        ],
                                                                        [
                                                                            12.335,
                                                                            -231.682
                                                                        ],
                                                                        [
                                                                            -134.562,
                                                                            -222.059
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    505.295,
                                                    296.313
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    505.295,
                                                    296.313
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            505.295,
                                            296.313
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            505.295,
                                            296.313
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111115",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11115",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 115",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -65.336,
                                                                            -255.985
                                                                        ],
                                                                        [
                                                                            -190.246,
                                                                            -248.01
                                                                        ],
                                                                        [
                                                                            -261.172,
                                                                            -215.874
                                                                        ],
                                                                        [
                                                                            -132.044,
                                                                            -222.646
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    376.746,
                                                    304.07
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    376.746,
                                                    304.07
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            376.746,
                                            304.07
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            376.746,
                                            304.07
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111116",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11116",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 116",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -71.41,
                                                                            -254.103
                                                                        ],
                                                                        [
                                                                            63.597,
                                                                            -263.315
                                                                        ],
                                                                        [
                                                                            112.808,
                                                                            -293.946
                                                                        ],
                                                                        [
                                                                            -18.546,
                                                                            -283.99
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    560.699,
                                                    265.975
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    560.699,
                                                    265.975
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            560.699,
                                            265.975
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            560.699,
                                            265.975
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Shape Layer 111111117",
                            "it": [
                                {
                                    "ty": "gr",
                                    "nm": "Shape Layer 11117",
                                    "it": [
                                        {
                                            "ty": "gr",
                                            "nm": "Shape Layer 117",
                                            "it": [
                                                {
                                                    "ty": "gr",
                                                    "nm": "Shape 1",
                                                    "it": [
                                                        {
                                                            "ty": "sh",
                                                            "nm": "Path 1",
                                                            "d": 1,
                                                            "ks": {
                                                                "a": 0,
                                                                "k": {
                                                                    "c": true,
                                                                    "i": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "o": [
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ],
                                                                        [
                                                                            0,
                                                                            0
                                                                        ]
                                                                    ],
                                                                    "v": [
                                                                        [
                                                                            -69.047,
                                                                            -252.87
                                                                        ],
                                                                        [
                                                                            -194.678,
                                                                            -246.13
                                                                        ],
                                                                        [
                                                                            -130.602,
                                                                            -275.522
                                                                        ],
                                                                        [
                                                                            -10.988,
                                                                            -284.257
                                                                        ]
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "ty": "st",
                                                            "nm": "Stroke 1",
                                                            "lc": 1,
                                                            "lj": 2,
                                                            "ml": 4,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            },
                                                            "w": {
                                                                "a": 0,
                                                                "k": 5
                                                            },
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    0.4039,
                                                                    0.3333,
                                                                    1
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "ty": "fl",
                                                            "nm": "Fill 1",
                                                            "c": {
                                                                "a": 0,
                                                                "k": [
                                                                    1,
                                                                    1,
                                                                    1
                                                                ]
                                                            },
                                                            "r": 1,
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        },
                                                        {
                                                            "ty": "tr",
                                                            "a": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "s": {
                                                                "a": 0,
                                                                "k": [
                                                                    100,
                                                                    100
                                                                ]
                                                            },
                                                            "p": {
                                                                "a": 0,
                                                                "k": [
                                                                    0,
                                                                    0
                                                                ]
                                                            },
                                                            "r": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "sa": {
                                                                "a": 0,
                                                                "k": 0
                                                            },
                                                            "o": {
                                                                "a": 0,
                                                                "k": 100
                                                            }
                                                        }
                                                    ]
                                                },
                                                {
                                                    "ty": "tr",
                                                    "a": {
                                                        "a": 0,
                                                        "k": [
                                                            0,
                                                            0
                                                        ]
                                                    },
                                                    "s": {
                                                        "a": 0,
                                                        "k": [
                                                            100,
                                                            100
                                                        ]
                                                    },
                                                    "p": {
                                                        "a": 0,
                                                        "k": [
                                                            540,
                                                            540
                                                        ]
                                                    },
                                                    "r": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "sa": {
                                                        "a": 0,
                                                        "k": 0
                                                    },
                                                    "o": {
                                                        "a": 0,
                                                        "k": 100
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "ty": "tr",
                                            "a": {
                                                "a": 0,
                                                "k": [
                                                    437.167,
                                                    274.807
                                                ]
                                            },
                                            "s": {
                                                "a": 0,
                                                "k": [
                                                    100,
                                                    100
                                                ]
                                            },
                                            "p": {
                                                "a": 0,
                                                "k": [
                                                    437.167,
                                                    274.807
                                                ]
                                            },
                                            "r": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "sa": {
                                                "a": 0,
                                                "k": 0
                                            },
                                            "o": {
                                                "a": 0,
                                                "k": 100
                                            }
                                        }
                                    ]
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            437.167,
                                            274.807
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            437.167,
                                            274.807
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "2R.svg",
            "id": "12",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "2R.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 38800,
                    "ip": 0,
                    "ln": "724",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                55.5,
                                66
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                55.5,
                                66
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -2.761
                                                ],
                                                [
                                                    3.461,
                                                    -1.75
                                                ],
                                                [
                                                    0.91,
                                                    1.877
                                                ],
                                                [
                                                    0,
                                                    0.812
                                                ],
                                                [
                                                    -3.461,
                                                    1.749
                                                ],
                                                [
                                                    -0.637,
                                                    0.102
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    3.475
                                                ],
                                                [
                                                    -2.655,
                                                    1.342
                                                ],
                                                [
                                                    -0.281,
                                                    -0.569
                                                ],
                                                [
                                                    0,
                                                    -3.475
                                                ],
                                                [
                                                    0.71,
                                                    -0.362
                                                ],
                                                [
                                                    2.463,
                                                    -0.397
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.264,
                                                    -3.298
                                                ],
                                                [
                                                    0,
                                                    6.165
                                                ],
                                                [
                                                    -5.831,
                                                    5.121
                                                ],
                                                [
                                                    -6.264,
                                                    3.041
                                                ],
                                                [
                                                    0,
                                                    -6.421
                                                ],
                                                [
                                                    2.033,
                                                    -7.11
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            54.245,
                                            64.552
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -3.397
                                                ],
                                                [
                                                    3.031,
                                                    -2.409
                                                ],
                                                [
                                                    0.305,
                                                    -0.189
                                                ],
                                                [
                                                    0,
                                                    4.248
                                                ],
                                                [
                                                    -3.46,
                                                    2.139
                                                ],
                                                [
                                                    -0.626,
                                                    0.124
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    3.87
                                                ],
                                                [
                                                    -0.297,
                                                    0.237
                                                ],
                                                [
                                                    -3.46,
                                                    2.139
                                                ],
                                                [
                                                    0,
                                                    -4.248
                                                ],
                                                [
                                                    0.694,
                                                    -0.43
                                                ],
                                                [
                                                    2.485,
                                                    -0.524
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    6.264,
                                                    -4.267
                                                ],
                                                [
                                                    0.9,
                                                    6.659
                                                ],
                                                [
                                                    -0.002,
                                                    7.299
                                                ],
                                                [
                                                    -6.264,
                                                    3.481
                                                ],
                                                [
                                                    -0.002,
                                                    -8.085
                                                ],
                                                [
                                                    1.983,
                                                    -8.914
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            80.867,
                                            49.155
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.527,
                                                    -4.399
                                                ],
                                                [
                                                    3.533,
                                                    -2.059
                                                ],
                                                [
                                                    2.527,
                                                    1.453
                                                ],
                                                [
                                                    0,
                                                    4.092
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.091
                                                ],
                                                [
                                                    -2.523,
                                                    4.4
                                                ],
                                                [
                                                    -3.533,
                                                    2.062
                                                ],
                                                [
                                                    -2.528,
                                                    -1.453
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.311,
                                                    -12.81
                                                ],
                                                [
                                                    13.311,
                                                    -12.773
                                                ],
                                                [
                                                    9.393,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    10.414
                                                ],
                                                [
                                                    -9.393,
                                                    11.357
                                                ],
                                                [
                                                    -13.311,
                                                    2.759
                                                ],
                                                [
                                                    -13.311,
                                                    2.723
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            69.122,
                                            78.017
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.726,
                                                    -0.442
                                                ],
                                                [
                                                    -0.011,
                                                    -0.002
                                                ],
                                                [
                                                    -0.645,
                                                    -0.643
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.75,
                                                    -2.992
                                                ],
                                                [
                                                    2.715,
                                                    -1.554
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.196,
                                                    0.072
                                                ],
                                                [
                                                    0,
                                                    0.209
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.621,
                                                    0.251
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.82,
                                                    0.993
                                                ],
                                                [
                                                    0.009,
                                                    0.01
                                                ],
                                                [
                                                    0,
                                                    2.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.002,
                                                    2.309
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.431,
                                                    1.965
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.154,
                                                    -1.232
                                                ],
                                                [
                                                    0.011,
                                                    0.002
                                                ],
                                                [
                                                    0.885,
                                                    0.228
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.112,
                                                    1.253
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    3.089
                                                ],
                                                [
                                                    -1.751,
                                                    2.991
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.137,
                                                    0.158
                                                ],
                                                [
                                                    -0.196,
                                                    -0.072
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.949,
                                                    1.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.284,
                                                    -0.197
                                                ],
                                                [
                                                    -0.009,
                                                    -0.01
                                                ],
                                                [
                                                    -1.015,
                                                    -1.249
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.269
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.729,
                                                    -3.977
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    30.975,
                                                    -56.189
                                                ],
                                                [
                                                    36.918,
                                                    -57.371
                                                ],
                                                [
                                                    36.951,
                                                    -57.365
                                                ],
                                                [
                                                    39.264,
                                                    -56.048
                                                ],
                                                [
                                                    39.494,
                                                    -55.806
                                                ],
                                                [
                                                    41.216,
                                                    -50.4
                                                ],
                                                [
                                                    41.216,
                                                    -9.563
                                                ],
                                                [
                                                    38.369,
                                                    -0.09
                                                ],
                                                [
                                                    31.472,
                                                    7.093
                                                ],
                                                [
                                                    4.517,
                                                    22.518
                                                ],
                                                [
                                                    -25.425,
                                                    57.419
                                                ],
                                                [
                                                    -25.579,
                                                    57.599
                                                ],
                                                [
                                                    -26.132,
                                                    57.741
                                                ],
                                                [
                                                    -26.458,
                                                    57.272
                                                ],
                                                [
                                                    -26.458,
                                                    40.245
                                                ],
                                                [
                                                    -30.975,
                                                    42.83
                                                ],
                                                [
                                                    -30.975,
                                                    42.831
                                                ],
                                                [
                                                    -36.41,
                                                    44.119
                                                ],
                                                [
                                                    -36.41,
                                                    44.118
                                                ],
                                                [
                                                    -39.618,
                                                    42.302
                                                ],
                                                [
                                                    -39.646,
                                                    42.273
                                                ],
                                                [
                                                    -41.216,
                                                    37.041
                                                ],
                                                [
                                                    -41.216,
                                                    -3.795
                                                ],
                                                [
                                                    -39.62,
                                                    -10.803
                                                ],
                                                [
                                                    -39.62,
                                                    -10.804
                                                ],
                                                [
                                                    -31.471,
                                                    -20.452
                                                ],
                                                [
                                                    15.456,
                                                    -47.309
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            68.339,
                                            73.707
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.134,
                                                    0.044
                                                ],
                                                [
                                                    -0.123,
                                                    -0.069
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.236
                                                ],
                                                [
                                                    0,
                                                    -2.061
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.832,
                                                    -1.003
                                                ],
                                                [
                                                    0.154,
                                                    -0.185
                                                ],
                                                [
                                                    0.21,
                                                    0.117
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.021,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.028,
                                                    0.026
                                                ],
                                                [
                                                    0,
                                                    2.482
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.989,
                                                    2.247
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.134,
                                                    -0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    0.127
                                                ],
                                                [
                                                    -0.963,
                                                    2.173
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.993
                                                ],
                                                [
                                                    0.153,
                                                    0.185
                                                ],
                                                [
                                                    -0.154,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.009
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.033,
                                                    -0.019
                                                ],
                                                [
                                                    -1.334,
                                                    -1.22
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.208
                                                ],
                                                [
                                                    0.057,
                                                    -0.129
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.969,
                                                    -33.378
                                                ],
                                                [
                                                    -11.565,
                                                    -33.339
                                                ],
                                                [
                                                    13.527,
                                                    -19.175
                                                ],
                                                [
                                                    13.738,
                                                    -18.537
                                                ],
                                                [
                                                    12.223,
                                                    -12.054
                                                ],
                                                [
                                                    12.223,
                                                    28.042
                                                ],
                                                [
                                                    13.57,
                                                    32.551
                                                ],
                                                [
                                                    13.569,
                                                    33.19
                                                ],
                                                [
                                                    12.941,
                                                    33.306
                                                ],
                                                [
                                                    1.202,
                                                    26.74
                                                ],
                                                [
                                                    -9.761,
                                                    20.602
                                                ],
                                                [
                                                    -9.826,
                                                    20.572
                                                ],
                                                [
                                                    -11.677,
                                                    19.539
                                                ],
                                                [
                                                    -11.77,
                                                    19.471
                                                ],
                                                [
                                                    -13.842,
                                                    13.81
                                                ],
                                                [
                                                    -13.842,
                                                    -26.285
                                                ],
                                                [
                                                    -12.268,
                                                    -33.105
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            14.342,
                                            82.45
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.135,
                                                    0.078
                                                ],
                                                [
                                                    -0.155,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.033,
                                                    -0.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.053,
                                                    -0.161
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.818,
                                                    1.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.154,
                                                    -0.09
                                                ],
                                                [
                                                    0,
                                                    -0.179
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.155,
                                                    -0.088
                                                ],
                                                [
                                                    0.155,
                                                    0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.178
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.154,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.039,
                                                    0.022
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.665,
                                                    0.824
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.336,
                                                    0.209
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.155,
                                                    -0.09
                                                ],
                                                [
                                                    0.155,
                                                    0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.179
                                                ],
                                                [
                                                    -0.155,
                                                    0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.152,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.02,
                                                    -0.152
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.778,
                                                    -11.395
                                                ],
                                                [
                                                    -12.279,
                                                    -11.396
                                                ],
                                                [
                                                    -0.545,
                                                    -4.65
                                                ],
                                                [
                                                    -0.546,
                                                    -4.65
                                                ],
                                                [
                                                    -0.436,
                                                    -4.57
                                                ],
                                                [
                                                    -0.433,
                                                    -4.565
                                                ],
                                                [
                                                    -0.397,
                                                    -4.527
                                                ],
                                                [
                                                    2.212,
                                                    -3.029
                                                ],
                                                [
                                                    2.213,
                                                    -3.029
                                                ],
                                                [
                                                    7.005,
                                                    -4.206
                                                ],
                                                [
                                                    12.278,
                                                    -7.246
                                                ],
                                                [
                                                    12.778,
                                                    -7.246
                                                ],
                                                [
                                                    13.028,
                                                    -6.813
                                                ],
                                                [
                                                    13.028,
                                                    10.962
                                                ],
                                                [
                                                    12.777,
                                                    11.395
                                                ],
                                                [
                                                    12.277,
                                                    11.395
                                                ],
                                                [
                                                    -12.675,
                                                    -3.079
                                                ],
                                                [
                                                    -12.679,
                                                    -3.081
                                                ],
                                                [
                                                    -12.783,
                                                    -3.143
                                                ],
                                                [
                                                    -13.028,
                                                    -3.574
                                                ],
                                                [
                                                    -13.028,
                                                    -10.962
                                                ],
                                                [
                                                    -13.024,
                                                    -11.029
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            29.188,
                                            120.018
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.521,
                                                    -0.121
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.029,
                                                    -0.016
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    -0.231
                                                ],
                                                [
                                                    0.242,
                                                    0.064
                                                ],
                                                [
                                                    2.036,
                                                    -1.188
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.679,
                                                    -3.938
                                                ],
                                                [
                                                    0.137,
                                                    -0.045
                                                ],
                                                [
                                                    0.124,
                                                    0.073
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.098,
                                                    0.231
                                                ],
                                                [
                                                    -3.476,
                                                    2.031
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    1.784,
                                                    -1.044
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.031,
                                                    0.011
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    0.126
                                                ],
                                                [
                                                    -0.096,
                                                    0.231
                                                ],
                                                [
                                                    -1.409,
                                                    -0.375
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.228,
                                                    1.886
                                                ],
                                                [
                                                    -0.056,
                                                    0.132
                                                ],
                                                [
                                                    -0.136,
                                                    0.045
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    -0.127
                                                ],
                                                [
                                                    1.733,
                                                    -4.113
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.8,
                                                    -30.382
                                                ],
                                                [
                                                    24.825,
                                                    -31.76
                                                ],
                                                [
                                                    25.127,
                                                    -31.728
                                                ],
                                                [
                                                    25.223,
                                                    -31.706
                                                ],
                                                [
                                                    25.313,
                                                    -31.665
                                                ],
                                                [
                                                    28.477,
                                                    -29.826
                                                ],
                                                [
                                                    51.148,
                                                    -16.643
                                                ],
                                                [
                                                    51.358,
                                                    -16.02
                                                ],
                                                [
                                                    50.768,
                                                    -15.728
                                                ],
                                                [
                                                    45.506,
                                                    -14.62
                                                ],
                                                [
                                                    45.507,
                                                    -14.619
                                                ],
                                                [
                                                    29.869,
                                                    -5.491
                                                ],
                                                [
                                                    -17.415,
                                                    22.117
                                                ],
                                                [
                                                    -25.206,
                                                    31.558
                                                ],
                                                [
                                                    -25.51,
                                                    31.836
                                                ],
                                                [
                                                    -25.919,
                                                    31.793
                                                ],
                                                [
                                                    -51.148,
                                                    16.964
                                                ],
                                                [
                                                    -51.356,
                                                    16.338
                                                ],
                                                [
                                                    -43.122,
                                                    6.354
                                                ],
                                                [
                                                    -43.121,
                                                    6.354
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            53.461,
                                            32.279
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "1R.svg",
            "id": "13",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "1R.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 38800,
                    "ip": 0,
                    "ln": "737",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                40,
                                44
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                40,
                                44
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -18.761
                                                ],
                                                [
                                                    4.243,
                                                    -3.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.134,
                                                    3.278
                                                ],
                                                [
                                                    0,
                                                    3.726
                                                ],
                                                [
                                                    16.375,
                                                    9.448
                                                ],
                                                [
                                                    2.829,
                                                    0.607
                                                ],
                                                [
                                                    3.017,
                                                    -1.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -7.072,
                                                    -4.081
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    8.222
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.225,
                                                    -1.865
                                                ],
                                                [
                                                    0.966,
                                                    -2.795
                                                ],
                                                [
                                                    0,
                                                    -18.761
                                                ],
                                                [
                                                    -3.127,
                                                    -1.804
                                                ],
                                                [
                                                    -3.905,
                                                    -0.835
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    5.096,
                                                    -1.801
                                                ],
                                                [
                                                    16.375,
                                                    9.448
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    34.143,
                                                    13.934
                                                ],
                                                [
                                                    27.349,
                                                    31.653
                                                ],
                                                [
                                                    23.049,
                                                    34.03
                                                ],
                                                [
                                                    8.365,
                                                    42.142
                                                ],
                                                [
                                                    13.465,
                                                    34.392
                                                ],
                                                [
                                                    14.954,
                                                    24.589
                                                ],
                                                [
                                                    -14.698,
                                                    -26.493
                                                ],
                                                [
                                                    -23.667,
                                                    -30.087
                                                ],
                                                [
                                                    -34.143,
                                                    -29.387
                                                ],
                                                [
                                                    -18.212,
                                                    -38.125
                                                ],
                                                [
                                                    -18.209,
                                                    -38.125
                                                ],
                                                [
                                                    -14.175,
                                                    -40.341
                                                ],
                                                [
                                                    -14.172,
                                                    -40.341
                                                ],
                                                [
                                                    4.492,
                                                    -37.148
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.85,
                                            41.721
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.37,
                                                    0.789
                                                ],
                                                [
                                                    0.444,
                                                    0.54
                                                ],
                                                [
                                                    1.098,
                                                    -0.146
                                                ],
                                                [
                                                    0.266,
                                                    -0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.294,
                                                    -0.65
                                                ],
                                                [
                                                    0.072,
                                                    -0.927
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.188,
                                                    -0.479
                                                ],
                                                [
                                                    -0.195,
                                                    -0.334
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.18,
                                                    -0.678
                                                ],
                                                [
                                                    -0.408,
                                                    -0.114
                                                ],
                                                [
                                                    -0.543,
                                                    0.306
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.107,
                                                    0.924
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.76
                                                ],
                                                [
                                                    -0.281,
                                                    -0.596
                                                ],
                                                [
                                                    -1.137,
                                                    -1.385
                                                ],
                                                [
                                                    -0.259,
                                                    0.036
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.337,
                                                    -2.114
                                                ],
                                                [
                                                    -0.632,
                                                    0.316
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.075,
                                                    0.493
                                                ],
                                                [
                                                    0.16,
                                                    0.409
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.85,
                                                    1.375
                                                ],
                                                [
                                                    0.412,
                                                    0.238
                                                ],
                                                [
                                                    0.803,
                                                    0.227
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    -0.323
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    17.068,
                                                    -2.194
                                                ],
                                                [
                                                    17.068,
                                                    -2.254
                                                ],
                                                [
                                                    16.407,
                                                    -4.62
                                                ],
                                                [
                                                    15.316,
                                                    -6.332
                                                ],
                                                [
                                                    11.688,
                                                    -8.342
                                                ],
                                                [
                                                    10.917,
                                                    -8.068
                                                ],
                                                [
                                                    4.989,
                                                    -4.719
                                                ],
                                                [
                                                    -5.703,
                                                    1.379
                                                ],
                                                [
                                                    -11.258,
                                                    -7.883
                                                ],
                                                [
                                                    -11.286,
                                                    -7.932
                                                ],
                                                [
                                                    -15.974,
                                                    -10.539
                                                ],
                                                [
                                                    -17.065,
                                                    -8.607
                                                ],
                                                [
                                                    -17.079,
                                                    -7.495
                                                ],
                                                [
                                                    -17.008,
                                                    -7.424
                                                ],
                                                [
                                                    -16.617,
                                                    -5.972
                                                ],
                                                [
                                                    -16.098,
                                                    -4.881
                                                ],
                                                [
                                                    -9.381,
                                                    6.377
                                                ],
                                                [
                                                    -8.894,
                                                    7.204
                                                ],
                                                [
                                                    -8.877,
                                                    7.236
                                                ],
                                                [
                                                    -5.7,
                                                    10.429
                                                ],
                                                [
                                                    -4.467,
                                                    10.962
                                                ],
                                                [
                                                    -2.406,
                                                    10.841
                                                ],
                                                [
                                                    0.284,
                                                    9.325
                                                ],
                                                [
                                                    10.338,
                                                    3.617
                                                ],
                                                [
                                                    16.066,
                                                    0.388
                                                ],
                                                [
                                                    17.079,
                                                    -1.466
                                                ],
                                                [
                                                    17.079,
                                                    -1.512
                                                ],
                                                [
                                                    17.079,
                                                    -2.197
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            30.875,
                                            50.607
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -18.761
                                                ],
                                                [
                                                    0.967,
                                                    -2.795
                                                ],
                                                [
                                                    2.224,
                                                    -1.864
                                                ],
                                                [
                                                    1.755,
                                                    -0.565
                                                ],
                                                [
                                                    6.912,
                                                    3.989
                                                ],
                                                [
                                                    0,
                                                    18.76
                                                ],
                                                [
                                                    -4.577,
                                                    3.335
                                                ],
                                                [
                                                    -1.013,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.906,
                                                    -0.835
                                                ],
                                                [
                                                    -3.127,
                                                    -1.804
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    3.725
                                                ],
                                                [
                                                    -1.133,
                                                    3.279
                                                ],
                                                [
                                                    -1.404,
                                                    1.176
                                                ],
                                                [
                                                    -5.043,
                                                    1.634
                                                ],
                                                [
                                                    -16.375,
                                                    -9.447
                                                ],
                                                [
                                                    0,
                                                    -8.578
                                                ],
                                                [
                                                    0.885,
                                                    -0.646
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.017,
                                                    -1.268
                                                ],
                                                [
                                                    2.828,
                                                    0.607
                                                ],
                                                [
                                                    16.375,
                                                    9.448
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.651,
                                                    16.85
                                                ],
                                                [
                                                    28.162,
                                                    26.652
                                                ],
                                                [
                                                    23.063,
                                                    34.402
                                                ],
                                                [
                                                    18.312,
                                                    37.027
                                                ],
                                                [
                                                    0,
                                                    33.713
                                                ],
                                                [
                                                    -29.651,
                                                    -17.368
                                                ],
                                                [
                                                    -22.299,
                                                    -35.518
                                                ],
                                                [
                                                    -19.449,
                                                    -37.127
                                                ],
                                                [
                                                    -19.445,
                                                    -37.127
                                                ],
                                                [
                                                    -8.969,
                                                    -37.826
                                                ],
                                                [
                                                    0,
                                                    -34.232
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            30.151,
                                            49.461
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -18.761
                                                ],
                                                [
                                                    0.966,
                                                    -2.795
                                                ],
                                                [
                                                    3.127,
                                                    1.804
                                                ],
                                                [
                                                    4.53,
                                                    5.828
                                                ],
                                                [
                                                    1.653,
                                                    2.874
                                                ],
                                                [
                                                    0,
                                                    9.303
                                                ],
                                                [
                                                    -0.97,
                                                    2.795
                                                ],
                                                [
                                                    -3.127,
                                                    -1.804
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    3.725
                                                ],
                                                [
                                                    -2.833,
                                                    -0.603
                                                ],
                                                [
                                                    -5.718,
                                                    -3.3
                                                ],
                                                [
                                                    -2.012,
                                                    -2.586
                                                ],
                                                [
                                                    -5.287,
                                                    -9.185
                                                ],
                                                [
                                                    0,
                                                    -3.722
                                                ],
                                                [
                                                    2.829,
                                                    0.607
                                                ],
                                                [
                                                    16.375,
                                                    9.448
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.057,
                                                    22.437
                                                ],
                                                [
                                                    18.568,
                                                    32.239
                                                ],
                                                [
                                                    9.595,
                                                    28.645
                                                ],
                                                [
                                                    -5.991,
                                                    14.584
                                                ],
                                                [
                                                    -11.507,
                                                    6.361
                                                ],
                                                [
                                                    -20.057,
                                                    -22.437
                                                ],
                                                [
                                                    -18.564,
                                                    -32.239
                                                ],
                                                [
                                                    -9.595,
                                                    -28.645
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 10,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8549,
                                            0.8078,
                                            0.9882
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            39.746,
                                            43.873
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Pre-comp 1",
            "id": "14",
            "fr": 60,
            "layers": [
                {
                    "ty": 5,
                    "nm": "You\xe2\x80\x99re on the Pro Plan \xe2\x80\x94 $49/month, 50,000 messages, 5 sites.",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "624",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                177.169,
                                246.077
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "t": {
                        "m": {
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ]
                            },
                            "g": 1
                        },
                        "p": {
                            "f": {
                                "a": 0,
                                "k": 0
                            },
                            "l": {
                                "a": 0,
                                "k": 0
                            },
                            "r": {
                                "a": 0,
                                "k": 0
                            },
                            "a": {
                                "a": 0,
                                "k": 0
                            },
                            "p": {
                                "a": 0,
                                "k": 0
                            }
                        },
                        "a": [],
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "f": "BDOGrotesk-Medium",
                                        "s": 11,
                                        "t": "Done. You\xe2\x80\x99re now on Enterprise \xe2\x80\x94 \x03$199/month.",
                                        "fc": [
                                            0,
                                            0,
                                            0
                                        ],
                                        "lh": 17,
                                        "tr": 57,
                                        "j": 0,
                                        "ca": 0
                                    },
                                    "t": 0
                                }
                            ]
                        }
                    },
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "625",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -152.54,
                                -115.762
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                117.486,
                                117.486
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                240.563,
                                250.238
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            137.586,
                                            32.635
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9098,
                                            0.8784,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            109.4
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -152.54,
                                            -115.762
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "626",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                137,
                                257.284
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 34,
                    "h": 34,
                    "refId": "20",
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "AI Chat card Outlines",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "627",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                219,
                                54
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                56.016,
                                47.753
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                287.856,
                                248.835
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    21.719,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -21.718
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    21.719
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -21.718,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    21.719,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -21.718
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    178.7,
                                                    -53.325
                                                ],
                                                [
                                                    -178.701,
                                                    -53.325
                                                ],
                                                [
                                                    -218.025,
                                                    -14
                                                ],
                                                [
                                                    -218.025,
                                                    53.325
                                                ],
                                                [
                                                    178.7,
                                                    53.325
                                                ],
                                                [
                                                    218.025,
                                                    14
                                                ],
                                                [
                                                    218.025,
                                                    -14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.35
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8706,
                                            0.8275,
                                            1
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9098,
                                            0.8784,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            218.77,
                                            54.873
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 4
                }
            ]
        },
        {
            "nm": "AI Chat icon.svg",
            "id": "20",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "AI Chat icon.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "17",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                17,
                                17
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.288,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0.241,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.247,
                                                    -0.165
                                                ],
                                                [
                                                    -0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.065
                                                ],
                                                [
                                                    -0.011,
                                                    -0.079
                                                ],
                                                [
                                                    0.027,
                                                    -0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.247,
                                                    0.165
                                                ],
                                                [
                                                    0.297,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.071,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.065
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    -0.027,
                                                    0.075
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.113,
                                                    -0.321
                                                ],
                                                [
                                                    -0.112,
                                                    -0.322
                                                ],
                                                [
                                                    -0.288,
                                                    -0.181
                                                ],
                                                [
                                                    -0.338,
                                                    0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.21,
                                                    0.21
                                                ],
                                                [
                                                    -0.058,
                                                    0.291
                                                ],
                                                [
                                                    0.114,
                                                    0.274
                                                ],
                                                [
                                                    0.246,
                                                    0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0
                                                ],
                                                [
                                                    0.07,
                                                    0.037
                                                ],
                                                [
                                                    0.046,
                                                    0.066
                                                ],
                                                [
                                                    0.011,
                                                    0.079
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.113,
                                                    0.321
                                                ],
                                                [
                                                    0.111,
                                                    0.321
                                                ],
                                                [
                                                    0.287,
                                                    0.182
                                                ],
                                                [
                                                    0.338,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.21,
                                                    -0.21
                                                ],
                                                [
                                                    0.058,
                                                    -0.291
                                                ],
                                                [
                                                    -0.113,
                                                    -0.274
                                                ],
                                                [
                                                    -0.246,
                                                    -0.165
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.037
                                                ],
                                                [
                                                    -0.046,
                                                    -0.066
                                                ],
                                                [
                                                    -0.011,
                                                    -0.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.914,
                                                    -8
                                                ],
                                                [
                                                    3.917,
                                                    -8.991
                                                ],
                                                [
                                                    3.3,
                                                    -9.768
                                                ],
                                                [
                                                    2.334,
                                                    -9.99
                                                ],
                                                [
                                                    1.44,
                                                    -9.561
                                                ],
                                                [
                                                    -7.56,
                                                    -0.561
                                                ],
                                                [
                                                    -7.971,
                                                    0.207
                                                ],
                                                [
                                                    -7.886,
                                                    1.074
                                                ],
                                                [
                                                    -7.333,
                                                    1.747
                                                ],
                                                [
                                                    -6.5,
                                                    2
                                                ],
                                                [
                                                    -2.498,
                                                    2
                                                ],
                                                [
                                                    -2.268,
                                                    2.056
                                                ],
                                                [
                                                    -2.09,
                                                    2.211
                                                ],
                                                [
                                                    -2.003,
                                                    2.431
                                                ],
                                                [
                                                    -2.027,
                                                    2.666
                                                ],
                                                [
                                                    -3.914,
                                                    8
                                                ],
                                                [
                                                    -3.916,
                                                    8.992
                                                ],
                                                [
                                                    -3.299,
                                                    9.768
                                                ],
                                                [
                                                    -2.333,
                                                    9.99
                                                ],
                                                [
                                                    -1.439,
                                                    9.56
                                                ],
                                                [
                                                    7.561,
                                                    0.56
                                                ],
                                                [
                                                    7.971,
                                                    -0.208
                                                ],
                                                [
                                                    7.885,
                                                    -1.074
                                                ],
                                                [
                                                    7.333,
                                                    -1.747
                                                ],
                                                [
                                                    6.5,
                                                    -2
                                                ],
                                                [
                                                    2.503,
                                                    -2
                                                ],
                                                [
                                                    2.273,
                                                    -2.056
                                                ],
                                                [
                                                    2.094,
                                                    -2.211
                                                ],
                                                [
                                                    2.007,
                                                    -2.431
                                                ],
                                                [
                                                    2.031,
                                                    -2.667
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            12
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -12
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.083
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.083
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    0,
                                                    -16.446
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    16.446,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    0,
                                                    16.446
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ],
                                                [
                                                    -16.446,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.109
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5137,
                                            0.3608,
                                            0.9608
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.902,
                                            0.8706,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            17,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Dots",
            "id": "21",
            "fr": 60,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 3",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "773",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.988,
                                                    66.577
                                                ],
                                                [
                                                    7.988,
                                                    122.528
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 106.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 116.999
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 134.999
                                                    },
                                                    {
                                                        "s": [
                                                            100
                                                        ],
                                                        "t": 602.995
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 2",
                    "sr": 1,
                    "st": 52,
                    "op": 4891,
                    "ip": 52,
                    "ln": "772",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                110.3,
                                -49.521
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                -105.455,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                283.286,
                                316.479
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    207.002,
                                                    -167.322
                                                ],
                                                [
                                                    207.002,
                                                    68.279
                                                ],
                                                [
                                                    13.598,
                                                    68.279
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 116.999
                                                    },
                                                    {
                                                        "s": [
                                                            400
                                                        ],
                                                        "t": 597.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 50
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 102
                                    }
                                ]
                            },
                            "m": 1
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 52,
                    "op": 4891,
                    "ip": 52,
                    "ln": "771",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                366
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Shape 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    207.002,
                                                    -167.322
                                                ],
                                                [
                                                    207.002,
                                                    68.279
                                                ],
                                                [
                                                    13.598,
                                                    68.279
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "d": [
                                        {
                                            "nm": "dash",
                                            "n": "d",
                                            "v": {
                                                "a": 0,
                                                "k": 10
                                            }
                                        },
                                        {
                                            "nm": "offset",
                                            "n": "o",
                                            "v": {
                                                "a": 1,
                                                "k": [
                                                    {
                                                        "o": {
                                                            "x": 0.167,
                                                            "y": 0.167
                                                        },
                                                        "i": {
                                                            "x": 0.833,
                                                            "y": 0.833
                                                        },
                                                        "s": [
                                                            0
                                                        ],
                                                        "t": 115
                                                    },
                                                    {
                                                        "s": [
                                                            400
                                                        ],
                                                        "t": 597.996
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "tm",
                            "nm": "Trim Paths 1",
                            "e": {
                                "a": 0,
                                "k": 0
                            },
                            "o": {
                                "a": 0,
                                "k": 0
                            },
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "s": [
                                            0
                                        ],
                                        "t": 50
                                    },
                                    {
                                        "s": [
                                            100
                                        ],
                                        "t": 102
                                    }
                                ]
                            },
                            "m": 1
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Webpage",
            "id": "22",
            "fr": 60,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "640",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                382,
                                159.906
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 556,
                    "h": 63,
                    "refId": "23",
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 1",
                    "sr": 1,
                    "st": 0,
                    "op": 4839,
                    "ip": 0,
                    "ln": "641",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                -64.742,
                                -113.483
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                317.258,
                                254.517
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Rectangle 1",
                            "it": [
                                {
                                    "ty": "rc",
                                    "nm": "Rectangle Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 20
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            427.195,
                                            155.066
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            130.111,
                                            130.111
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            -0.395,
                                            -137.752
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "Webpage header.svg",
            "id": "23",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Webpage header.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 4840,
                    "ip": 0,
                    "ln": "654",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                278,
                                31.5
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.664
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.311,
                                                    0.672
                                                ],
                                                [
                                                    -0.576,
                                                    0.36
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.36
                                                ],
                                                [
                                                    -0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.583,
                                                    -0.36
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.36
                                                ],
                                                [
                                                    -0.311,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.584,
                                                    -0.36
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.312,
                                                    0.664
                                                ],
                                                [
                                                    -0.577,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    4.452
                                                ],
                                                [
                                                    -15.294,
                                                    3.912
                                                ],
                                                [
                                                    -16.626,
                                                    2.376
                                                ],
                                                [
                                                    -17.094,
                                                    0.012
                                                ],
                                                [
                                                    -16.626,
                                                    -2.364
                                                ],
                                                [
                                                    -15.294,
                                                    -3.912
                                                ],
                                                [
                                                    -13.242,
                                                    -4.452
                                                ],
                                                [
                                                    -11.201,
                                                    -3.912
                                                ],
                                                [
                                                    -9.858,
                                                    -2.364
                                                ],
                                                [
                                                    -9.39,
                                                    0.012
                                                ],
                                                [
                                                    -9.858,
                                                    2.376
                                                ],
                                                [
                                                    -11.201,
                                                    3.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.52
                                                ],
                                                [
                                                    0.416,
                                                    0.272
                                                ],
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ],
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.272
                                                ],
                                                [
                                                    -0.216,
                                                    0.52
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.512
                                                ],
                                                [
                                                    0.416,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    3.468
                                                ],
                                                [
                                                    -11.718,
                                                    3.072
                                                ],
                                                [
                                                    -10.77,
                                                    1.896
                                                ],
                                                [
                                                    -10.446,
                                                    0.012
                                                ],
                                                [
                                                    -10.77,
                                                    -1.872
                                                ],
                                                [
                                                    -11.718,
                                                    -3.06
                                                ],
                                                [
                                                    -13.242,
                                                    -3.468
                                                ],
                                                [
                                                    -14.766,
                                                    -3.06
                                                ],
                                                [
                                                    -15.714,
                                                    -1.872
                                                ],
                                                [
                                                    -16.038,
                                                    0.012
                                                ],
                                                [
                                                    -15.714,
                                                    1.896
                                                ],
                                                [
                                                    -14.766,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.113,
                                                    -2.1
                                                ],
                                                [
                                                    -7.065,
                                                    -0.468
                                                ],
                                                [
                                                    -7.197,
                                                    -0.6
                                                ],
                                                [
                                                    -6.477,
                                                    -1.824
                                                ],
                                                [
                                                    -5.121,
                                                    -2.244
                                                ],
                                                [
                                                    -3.525,
                                                    -1.572
                                                ],
                                                [
                                                    -2.973,
                                                    0.168
                                                ],
                                                [
                                                    -2.973,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    0.456
                                                ],
                                                [
                                                    -4.101,
                                                    -0.54
                                                ],
                                                [
                                                    -4.545,
                                                    -1.152
                                                ],
                                                [
                                                    -5.325,
                                                    -1.368
                                                ],
                                                [
                                                    -6.573,
                                                    -0.888
                                                ],
                                                [
                                                    -7.029,
                                                    0.456
                                                ],
                                                [
                                                    -7.029,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.064
                                                ],
                                                [
                                                    -0.136,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.232,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.072,
                                                    0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.232
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.161,
                                                    -4.26
                                                ],
                                                [
                                                    -0.161,
                                                    2.988
                                                ],
                                                [
                                                    -0.065,
                                                    3.288
                                                ],
                                                [
                                                    0.247,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    4.26
                                                ],
                                                [
                                                    0.103,
                                                    4.26
                                                ],
                                                [
                                                    -0.809,
                                                    3.924
                                                ],
                                                [
                                                    -1.145,
                                                    3.036
                                                ],
                                                [
                                                    -1.145,
                                                    -4.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.178,
                                                    -2.1
                                                ],
                                                [
                                                    3.178,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.202,
                                                    -4.236
                                                ],
                                                [
                                                    3.202,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -4.236
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.941,
                                                    -2.1
                                                ],
                                                [
                                                    5.989,
                                                    -0.468
                                                ],
                                                [
                                                    5.857,
                                                    -0.6
                                                ],
                                                [
                                                    6.577,
                                                    -1.824
                                                ],
                                                [
                                                    7.933,
                                                    -2.244
                                                ],
                                                [
                                                    9.529,
                                                    -1.572
                                                ],
                                                [
                                                    10.081,
                                                    0.168
                                                ],
                                                [
                                                    10.081,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    0.456
                                                ],
                                                [
                                                    8.953,
                                                    -0.54
                                                ],
                                                [
                                                    8.509,
                                                    -1.152
                                                ],
                                                [
                                                    7.729,
                                                    -1.368
                                                ],
                                                [
                                                    6.481,
                                                    -0.888
                                                ],
                                                [
                                                    6.025,
                                                    0.456
                                                ],
                                                [
                                                    6.025,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    -0.24,
                                                    0.496
                                                ],
                                                [
                                                    -0.431,
                                                    0.272
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.4,
                                                    -0.224
                                                ],
                                                [
                                                    -0.248,
                                                    -0.48
                                                ],
                                                [
                                                    -0.032,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.368
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.192
                                                ],
                                                [
                                                    -0.144,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.352
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.272
                                                ],
                                                [
                                                    0.24,
                                                    0.496
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.24,
                                                    -0.504
                                                ],
                                                [
                                                    0.44,
                                                    -0.272
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.224
                                                ],
                                                [
                                                    0.256,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.656
                                                ],
                                                [
                                                    0.328,
                                                    0.36
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    0.592
                                                ],
                                                [
                                                    -0.488,
                                                    0.352
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.431,
                                                    -0.272
                                                ],
                                                [
                                                    -0.24,
                                                    -0.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.417,
                                                    1.08
                                                ],
                                                [
                                                    11.777,
                                                    -0.672
                                                ],
                                                [
                                                    12.785,
                                                    -1.836
                                                ],
                                                [
                                                    14.321,
                                                    -2.244
                                                ],
                                                [
                                                    15.665,
                                                    -1.908
                                                ],
                                                [
                                                    16.649,
                                                    -0.852
                                                ],
                                                [
                                                    17.081,
                                                    0.948
                                                ],
                                                [
                                                    17.093,
                                                    1.392
                                                ],
                                                [
                                                    12.461,
                                                    1.392
                                                ],
                                                [
                                                    13.013,
                                                    2.928
                                                ],
                                                [
                                                    14.321,
                                                    3.468
                                                ],
                                                [
                                                    15.281,
                                                    3.18
                                                ],
                                                [
                                                    15.929,
                                                    2.388
                                                ],
                                                [
                                                    16.985,
                                                    2.46
                                                ],
                                                [
                                                    15.977,
                                                    3.876
                                                ],
                                                [
                                                    14.321,
                                                    4.404
                                                ],
                                                [
                                                    12.785,
                                                    3.996
                                                ],
                                                [
                                                    11.777,
                                                    2.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    0.288
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.32
                                                ],
                                                [
                                                    0.088,
                                                    -0.584
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.088,
                                                    -0.632
                                                ],
                                                [
                                                    -0.304,
                                                    -0.296
                                                ],
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.013,
                                                    0.516
                                                ],
                                                [
                                                    15.425,
                                                    -0.864
                                                ],
                                                [
                                                    14.321,
                                                    -1.308
                                                ],
                                                [
                                                    13.085,
                                                    -0.828
                                                ],
                                                [
                                                    12.485,
                                                    0.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9333,
                                            0.9255,
                                            0.9255
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            94.682,
                                            43.24
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ],
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ],
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -4.5
                                                ],
                                                [
                                                    4.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.5
                                                ],
                                                [
                                                    -4.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            64.5,
                                            43.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.437,
                                                    0.896
                                                ],
                                                [
                                                    0,
                                                    1.12
                                                ],
                                                [
                                                    -0.427,
                                                    0.907
                                                ],
                                                [
                                                    -0.811,
                                                    0.512
                                                ],
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.811,
                                                    -0.523
                                                ],
                                                [
                                                    -0.427,
                                                    -0.907
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.373,
                                                    -0.853
                                                ],
                                                [
                                                    0.672,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.8,
                                                    -0.523
                                                ],
                                                [
                                                    -0.437,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.12
                                                ],
                                                [
                                                    0.437,
                                                    -0.907
                                                ],
                                                [
                                                    0.811,
                                                    -0.523
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.811,
                                                    0.512
                                                ],
                                                [
                                                    0.427,
                                                    0.907
                                                ],
                                                [
                                                    0,
                                                    1.024
                                                ],
                                                [
                                                    -0.363,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.64,
                                                    0.245
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.291,
                                                    5.544
                                                ],
                                                [
                                                    -48.123,
                                                    4.776
                                                ],
                                                [
                                                    -49.979,
                                                    2.648
                                                ],
                                                [
                                                    -50.635,
                                                    -0.376
                                                ],
                                                [
                                                    -49.995,
                                                    -3.416
                                                ],
                                                [
                                                    -48.123,
                                                    -5.544
                                                ],
                                                [
                                                    -45.291,
                                                    -6.328
                                                ],
                                                [
                                                    -42.443,
                                                    -5.544
                                                ],
                                                [
                                                    -40.587,
                                                    -3.416
                                                ],
                                                [
                                                    -39.947,
                                                    -0.376
                                                ],
                                                [
                                                    -40.507,
                                                    2.44
                                                ],
                                                [
                                                    -42.059,
                                                    4.488
                                                ],
                                                [
                                                    -40.603,
                                                    6.328
                                                ],
                                                [
                                                    -42.331,
                                                    6.328
                                                ],
                                                [
                                                    -43.227,
                                                    5.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.245,
                                                    -0.629
                                                ],
                                                [
                                                    -0.491,
                                                    -0.373
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.245,
                                                    -0.629
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.768
                                                ],
                                                [
                                                    0.245,
                                                    0.619
                                                ],
                                                [
                                                    0.491,
                                                    0.373
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.373
                                                ],
                                                [
                                                    0.213,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.235,
                                                    -0.629
                                                ],
                                                [
                                                    -0.48,
                                                    -0.384
                                                ],
                                                [
                                                    -0.715,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ],
                                                [
                                                    -0.245,
                                                    0.619
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.555,
                                                    -0.376
                                                ],
                                                [
                                                    -48.187,
                                                    1.72
                                                ],
                                                [
                                                    -47.083,
                                                    3.208
                                                ],
                                                [
                                                    -45.291,
                                                    3.768
                                                ],
                                                [
                                                    -44.443,
                                                    3.656
                                                ],
                                                [
                                                    -46.011,
                                                    1.656
                                                ],
                                                [
                                                    -44.283,
                                                    1.656
                                                ],
                                                [
                                                    -43.275,
                                                    2.968
                                                ],
                                                [
                                                    -42.347,
                                                    1.544
                                                ],
                                                [
                                                    -42.027,
                                                    -0.376
                                                ],
                                                [
                                                    -42.395,
                                                    -2.472
                                                ],
                                                [
                                                    -43.483,
                                                    -3.976
                                                ],
                                                [
                                                    -45.291,
                                                    -4.552
                                                ],
                                                [
                                                    -47.099,
                                                    -3.976
                                                ],
                                                [
                                                    -48.187,
                                                    -2.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.384
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.502,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.32
                                                ],
                                                [
                                                    -0.202,
                                                    -0.171
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    0.811
                                                ],
                                                [
                                                    -0.49,
                                                    0.373
                                                ],
                                                [
                                                    -0.906,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    0.107,
                                                    0.32
                                                ],
                                                [
                                                    0.214,
                                                    0.16
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.526,
                                                    5.288
                                                ],
                                                [
                                                    -32.574,
                                                    2.984
                                                ],
                                                [
                                                    -32.318,
                                                    3.128
                                                ],
                                                [
                                                    -33.262,
                                                    4.92
                                                ],
                                                [
                                                    -35.054,
                                                    5.48
                                                ],
                                                [
                                                    -37.166,
                                                    4.6
                                                ],
                                                [
                                                    -37.918,
                                                    2.264
                                                ],
                                                [
                                                    -37.918,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    -3.192
                                                ],
                                                [
                                                    -35.934,
                                                    1.624
                                                ],
                                                [
                                                    -35.79,
                                                    2.872
                                                ],
                                                [
                                                    -35.326,
                                                    3.608
                                                ],
                                                [
                                                    -34.462,
                                                    3.848
                                                ],
                                                [
                                                    -33.15,
                                                    3.288
                                                ],
                                                [
                                                    -32.67,
                                                    1.624
                                                ],
                                                [
                                                    -32.67,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    -3.192
                                                ],
                                                [
                                                    -30.686,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.352,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.661
                                                ],
                                                [
                                                    -0.618,
                                                    0.363
                                                ],
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.629,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.342,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.618,
                                                    -0.363
                                                ],
                                                [
                                                    -0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.352,
                                                    -0.672
                                                ],
                                                [
                                                    0.63,
                                                    -0.363
                                                ],
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    0.363
                                                ],
                                                [
                                                    0.342,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.341,
                                                    0.672
                                                ],
                                                [
                                                    -0.629,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    5.48
                                                ],
                                                [
                                                    -26.84,
                                                    4.936
                                                ],
                                                [
                                                    -28.296,
                                                    3.384
                                                ],
                                                [
                                                    -28.808,
                                                    1.048
                                                ],
                                                [
                                                    -28.296,
                                                    -1.288
                                                ],
                                                [
                                                    -26.84,
                                                    -2.84
                                                ],
                                                [
                                                    -24.648,
                                                    -3.384
                                                ],
                                                [
                                                    -22.456,
                                                    -2.84
                                                ],
                                                [
                                                    -21,
                                                    -1.288
                                                ],
                                                [
                                                    -20.488,
                                                    1.048
                                                ],
                                                [
                                                    -21,
                                                    3.384
                                                ],
                                                [
                                                    -22.456,
                                                    4.936
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.363,
                                                    0.491
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.885
                                                ],
                                                [
                                                    -0.362,
                                                    -0.491
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.374,
                                                    0.491
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.648,
                                                    3.848
                                                ],
                                                [
                                                    -23.08,
                                                    3.112
                                                ],
                                                [
                                                    -22.536,
                                                    1.048
                                                ],
                                                [
                                                    -23.08,
                                                    -1.016
                                                ],
                                                [
                                                    -24.648,
                                                    -1.752
                                                ],
                                                [
                                                    -26.216,
                                                    -1.016
                                                ],
                                                [
                                                    -26.76,
                                                    1.048
                                                ],
                                                [
                                                    -26.216,
                                                    3.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.749,
                                                    -6.072
                                                ],
                                                [
                                                    -16.749,
                                                    0.696
                                                ],
                                                [
                                                    -13.245,
                                                    -3.192
                                                ],
                                                [
                                                    -10.781,
                                                    -3.192
                                                ],
                                                [
                                                    -14.093,
                                                    0.328
                                                ],
                                                [
                                                    -10.637,
                                                    5.288
                                                ],
                                                [
                                                    -12.877,
                                                    5.288
                                                ],
                                                [
                                                    -15.389,
                                                    1.528
                                                ],
                                                [
                                                    -16.749,
                                                    3
                                                ],
                                                [
                                                    -16.749,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    5.288
                                                ],
                                                [
                                                    -18.733,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.702,
                                                    -6.072
                                                ],
                                                [
                                                    -6.702,
                                                    0.696
                                                ],
                                                [
                                                    -3.198,
                                                    -3.192
                                                ],
                                                [
                                                    -0.734,
                                                    -3.192
                                                ],
                                                [
                                                    -4.046,
                                                    0.328
                                                ],
                                                [
                                                    -0.59,
                                                    5.288
                                                ],
                                                [
                                                    -2.83,
                                                    5.288
                                                ],
                                                [
                                                    -5.342,
                                                    1.528
                                                ],
                                                [
                                                    -6.702,
                                                    3
                                                ],
                                                [
                                                    -6.702,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    5.288
                                                ],
                                                [
                                                    -8.686,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.821,
                                                    -0.616
                                                ],
                                                [
                                                    2.053,
                                                    -2.648
                                                ],
                                                [
                                                    4.565,
                                                    -3.384
                                                ],
                                                [
                                                    7.333,
                                                    -2.456
                                                ],
                                                [
                                                    8.277,
                                                    0.248
                                                ],
                                                [
                                                    8.277,
                                                    3.208
                                                ],
                                                [
                                                    8.405,
                                                    3.688
                                                ],
                                                [
                                                    8.805,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    3.816
                                                ],
                                                [
                                                    9.125,
                                                    5.288
                                                ],
                                                [
                                                    8.629,
                                                    5.304
                                                ],
                                                [
                                                    8.565,
                                                    5.304
                                                ],
                                                [
                                                    7.685,
                                                    5.24
                                                ],
                                                [
                                                    6.917,
                                                    4.872
                                                ],
                                                [
                                                    6.533,
                                                    3.992
                                                ],
                                                [
                                                    5.493,
                                                    5.064
                                                ],
                                                [
                                                    3.733,
                                                    5.48
                                                ],
                                                [
                                                    1.541,
                                                    4.824
                                                ],
                                                [
                                                    0.677,
                                                    3.064
                                                ],
                                                [
                                                    1.045,
                                                    1.768
                                                ],
                                                [
                                                    2.101,
                                                    0.984
                                                ],
                                                [
                                                    3.893,
                                                    0.488
                                                ],
                                                [
                                                    6.277,
                                                    0.008
                                                ],
                                                [
                                                    5.845,
                                                    -1.432
                                                ],
                                                [
                                                    4.565,
                                                    -1.912
                                                ],
                                                [
                                                    3.445,
                                                    -1.544
                                                ],
                                                [
                                                    2.853,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.725,
                                                    3
                                                ],
                                                [
                                                    3.109,
                                                    3.768
                                                ],
                                                [
                                                    4.245,
                                                    4.056
                                                ],
                                                [
                                                    5.301,
                                                    3.768
                                                ],
                                                [
                                                    6.037,
                                                    2.904
                                                ],
                                                [
                                                    6.309,
                                                    1.48
                                                ],
                                                [
                                                    6.309,
                                                    1.4
                                                ],
                                                [
                                                    4.677,
                                                    1.688
                                                ],
                                                [
                                                    4.389,
                                                    1.736
                                                ],
                                                [
                                                    3.461,
                                                    1.96
                                                ],
                                                [
                                                    2.933,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    14.739,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    -6.072
                                                ],
                                                [
                                                    16.755,
                                                    4.632
                                                ],
                                                [
                                                    15.651,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    3.512
                                                ],
                                                [
                                                    22.163,
                                                    5.288
                                                ],
                                                [
                                                    14.739,
                                                    5.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.053
                                                ],
                                                [
                                                    0.224,
                                                    0.192
                                                ],
                                                [
                                                    0.032,
                                                    0.395
                                                ],
                                                [
                                                    0.48,
                                                    -0.277
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.246,
                                                    0.331
                                                ],
                                                [
                                                    -0.448,
                                                    0.192
                                                ],
                                                [
                                                    -0.736,
                                                    0.139
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.277,
                                                    0.309
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.245
                                                ],
                                                [
                                                    0.106,
                                                    -0.459
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.17,
                                                    -0.875
                                                ],
                                                [
                                                    0.65,
                                                    -0.491
                                                ],
                                                [
                                                    1.216,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.224
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.011
                                                ],
                                                [
                                                    -0.288,
                                                    -0.053
                                                ],
                                                [
                                                    -0.224,
                                                    -0.192
                                                ],
                                                [
                                                    -0.214,
                                                    0.437
                                                ],
                                                [
                                                    -0.48,
                                                    0.277
                                                ],
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.256,
                                                    -0.331
                                                ],
                                                [
                                                    0.458,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.011,
                                                    -0.651
                                                ],
                                                [
                                                    -0.278,
                                                    -0.32
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.618,
                                                    -0.616
                                                ],
                                                [
                                                    24.85,
                                                    -2.648
                                                ],
                                                [
                                                    27.362,
                                                    -3.384
                                                ],
                                                [
                                                    30.13,
                                                    -2.456
                                                ],
                                                [
                                                    31.074,
                                                    0.248
                                                ],
                                                [
                                                    31.074,
                                                    3.208
                                                ],
                                                [
                                                    31.202,
                                                    3.688
                                                ],
                                                [
                                                    31.602,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    3.816
                                                ],
                                                [
                                                    31.922,
                                                    5.288
                                                ],
                                                [
                                                    31.426,
                                                    5.304
                                                ],
                                                [
                                                    31.362,
                                                    5.304
                                                ],
                                                [
                                                    30.482,
                                                    5.24
                                                ],
                                                [
                                                    29.714,
                                                    4.872
                                                ],
                                                [
                                                    29.33,
                                                    3.992
                                                ],
                                                [
                                                    28.29,
                                                    5.064
                                                ],
                                                [
                                                    26.53,
                                                    5.48
                                                ],
                                                [
                                                    24.338,
                                                    4.824
                                                ],
                                                [
                                                    23.474,
                                                    3.064
                                                ],
                                                [
                                                    23.842,
                                                    1.768
                                                ],
                                                [
                                                    24.898,
                                                    0.984
                                                ],
                                                [
                                                    26.69,
                                                    0.488
                                                ],
                                                [
                                                    29.074,
                                                    0.008
                                                ],
                                                [
                                                    28.642,
                                                    -1.432
                                                ],
                                                [
                                                    27.362,
                                                    -1.912
                                                ],
                                                [
                                                    26.242,
                                                    -1.544
                                                ],
                                                [
                                                    25.65,
                                                    -0.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.288
                                                ],
                                                [
                                                    -0.256,
                                                    -0.203
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.192
                                                ],
                                                [
                                                    -0.171,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.075
                                                ],
                                                [
                                                    0.138,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.309
                                                ],
                                                [
                                                    0.266,
                                                    0.192
                                                ],
                                                [
                                                    0.394,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0.181,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.075
                                                ],
                                                [
                                                    -0.214,
                                                    0.075
                                                ],
                                                [
                                                    -0.139,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.522,
                                                    3
                                                ],
                                                [
                                                    25.906,
                                                    3.768
                                                ],
                                                [
                                                    27.042,
                                                    4.056
                                                ],
                                                [
                                                    28.098,
                                                    3.768
                                                ],
                                                [
                                                    28.834,
                                                    2.904
                                                ],
                                                [
                                                    29.106,
                                                    1.48
                                                ],
                                                [
                                                    29.106,
                                                    1.4
                                                ],
                                                [
                                                    27.474,
                                                    1.688
                                                ],
                                                [
                                                    27.186,
                                                    1.736
                                                ],
                                                [
                                                    26.258,
                                                    1.96
                                                ],
                                                [
                                                    25.73,
                                                    2.328
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.224
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.395
                                                ],
                                                [
                                                    -0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.395
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.235
                                                ],
                                                [
                                                    0.245,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.256,
                                                    -0.437
                                                ],
                                                [
                                                    0.427,
                                                    -0.224
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.395
                                                ],
                                                [
                                                    0.267,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.267,
                                                    0.672
                                                ],
                                                [
                                                    -0.533,
                                                    0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    -0.245
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.595,
                                                    -6.072
                                                ],
                                                [
                                                    35.595,
                                                    -2.056
                                                ],
                                                [
                                                    36.619,
                                                    -3.048
                                                ],
                                                [
                                                    38.139,
                                                    -3.384
                                                ],
                                                [
                                                    40.107,
                                                    -2.792
                                                ],
                                                [
                                                    41.323,
                                                    -1.192
                                                ],
                                                [
                                                    41.723,
                                                    1.048
                                                ],
                                                [
                                                    41.323,
                                                    3.288
                                                ],
                                                [
                                                    40.107,
                                                    4.888
                                                ],
                                                [
                                                    38.139,
                                                    5.48
                                                ],
                                                [
                                                    36.555,
                                                    5.128
                                                ],
                                                [
                                                    35.531,
                                                    4.088
                                                ],
                                                [
                                                    35.483,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    5.288
                                                ],
                                                [
                                                    33.611,
                                                    -6.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    -0.149,
                                                    -0.427
                                                ],
                                                [
                                                    -0.309,
                                                    -0.256
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.533
                                                ],
                                                [
                                                    0,
                                                    0.789
                                                ],
                                                [
                                                    0.352,
                                                    0.544
                                                ],
                                                [
                                                    0.704,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.267
                                                ],
                                                [
                                                    0.149,
                                                    -0.427
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0.501
                                                ],
                                                [
                                                    0.149,
                                                    0.427
                                                ],
                                                [
                                                    0.32,
                                                    0.256
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.544
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.352,
                                                    -0.544
                                                ],
                                                [
                                                    -0.469,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.256
                                                ],
                                                [
                                                    -0.149,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.467,
                                                    1.048
                                                ],
                                                [
                                                    35.691,
                                                    2.44
                                                ],
                                                [
                                                    36.379,
                                                    3.464
                                                ],
                                                [
                                                    37.579,
                                                    3.848
                                                ],
                                                [
                                                    39.147,
                                                    3.048
                                                ],
                                                [
                                                    39.691,
                                                    1.048
                                                ],
                                                [
                                                    39.163,
                                                    -1
                                                ],
                                                [
                                                    37.579,
                                                    -1.816
                                                ],
                                                [
                                                    36.395,
                                                    -1.416
                                                ],
                                                [
                                                    35.691,
                                                    -0.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.245
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.278,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    -0.331
                                                ],
                                                [
                                                    -0.32,
                                                    -0.181
                                                ],
                                                [
                                                    -0.512,
                                                    -0.096
                                                ],
                                                [
                                                    -0.512,
                                                    -0.203
                                                ],
                                                [
                                                    -0.266,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    -0.533
                                                ],
                                                [
                                                    0.32,
                                                    -0.363
                                                ],
                                                [
                                                    0.544,
                                                    -0.181
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.235
                                                ],
                                                [
                                                    0.342,
                                                    0.427
                                                ],
                                                [
                                                    0.054,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -0.213
                                                ],
                                                [
                                                    -0.266,
                                                    -0.117
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.16
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    0.139,
                                                    0.139
                                                ],
                                                [
                                                    0.203,
                                                    0.064
                                                ],
                                                [
                                                    0.342,
                                                    0.075
                                                ],
                                                [
                                                    0.15,
                                                    0.043
                                                ],
                                                [
                                                    0.48,
                                                    0.181
                                                ],
                                                [
                                                    0.288,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    -0.288,
                                                    0.405
                                                ],
                                                [
                                                    -0.533,
                                                    0.213
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.65,
                                                    -0.512
                                                ],
                                                [
                                                    -0.138,
                                                    -0.864
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.085,
                                                    -0.427
                                                ],
                                                [
                                                    -0.33,
                                                    -0.245
                                                ],
                                                [
                                                    -0.416,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.203
                                                ],
                                                [
                                                    0.011,
                                                    0.331
                                                ],
                                                [
                                                    0.32,
                                                    0.171
                                                ],
                                                [
                                                    0.811,
                                                    0.139
                                                ],
                                                [
                                                    0.512,
                                                    0.192
                                                ],
                                                [
                                                    0.278,
                                                    0.341
                                                ],
                                                [
                                                    0,
                                                    0.544
                                                ],
                                                [
                                                    -0.32,
                                                    0.363
                                                ],
                                                [
                                                    -0.533,
                                                    0.181
                                                ],
                                                [
                                                    -0.757,
                                                    0
                                                ],
                                                [
                                                    -0.586,
                                                    -0.235
                                                ],
                                                [
                                                    -0.33,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.309
                                                ],
                                                [
                                                    0.171,
                                                    0.213
                                                ],
                                                [
                                                    0.267,
                                                    0.117
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.16
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.128,
                                                    -0.139
                                                ],
                                                [
                                                    -0.192,
                                                    -0.075
                                                ],
                                                [
                                                    -0.085,
                                                    -0.011
                                                ],
                                                [
                                                    -0.778,
                                                    -0.16
                                                ],
                                                [
                                                    -0.48,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.331
                                                ],
                                                [
                                                    0,
                                                    -0.544
                                                ],
                                                [
                                                    0.299,
                                                    -0.405
                                                ],
                                                [
                                                    0.544,
                                                    -0.224
                                                ],
                                                [
                                                    0.982,
                                                    0
                                                ],
                                                [
                                                    0.662,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.523,
                                                    -0.488
                                                ],
                                                [
                                                    47.883,
                                                    -1.496
                                                ],
                                                [
                                                    46.763,
                                                    -1.864
                                                ],
                                                [
                                                    45.723,
                                                    -1.56
                                                ],
                                                [
                                                    45.323,
                                                    -0.76
                                                ],
                                                [
                                                    45.819,
                                                    0.008
                                                ],
                                                [
                                                    47.067,
                                                    0.408
                                                ],
                                                [
                                                    49.051,
                                                    0.92
                                                ],
                                                [
                                                    50.219,
                                                    1.72
                                                ],
                                                [
                                                    50.635,
                                                    3.032
                                                ],
                                                [
                                                    50.155,
                                                    4.392
                                                ],
                                                [
                                                    48.859,
                                                    5.208
                                                ],
                                                [
                                                    47.051,
                                                    5.48
                                                ],
                                                [
                                                    45.035,
                                                    5.128
                                                ],
                                                [
                                                    43.643,
                                                    4.136
                                                ],
                                                [
                                                    43.067,
                                                    2.6
                                                ],
                                                [
                                                    45.099,
                                                    2.488
                                                ],
                                                [
                                                    45.419,
                                                    3.272
                                                ],
                                                [
                                                    46.075,
                                                    3.768
                                                ],
                                                [
                                                    47.019,
                                                    3.944
                                                ],
                                                [
                                                    48.107,
                                                    3.704
                                                ],
                                                [
                                                    48.587,
                                                    2.968
                                                ],
                                                [
                                                    48.379,
                                                    2.424
                                                ],
                                                [
                                                    47.883,
                                                    2.12
                                                ],
                                                [
                                                    47.083,
                                                    1.896
                                                ],
                                                [
                                                    46.731,
                                                    1.816
                                                ],
                                                [
                                                    44.843,
                                                    1.304
                                                ],
                                                [
                                                    43.691,
                                                    0.552
                                                ],
                                                [
                                                    43.275,
                                                    -0.712
                                                ],
                                                [
                                                    43.707,
                                                    -2.136
                                                ],
                                                [
                                                    44.955,
                                                    -3.064
                                                ],
                                                [
                                                    46.875,
                                                    -3.4
                                                ],
                                                [
                                                    49.323,
                                                    -2.632
                                                ],
                                                [
                                                    50.523,
                                                    -0.584
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9216,
                                            0.9216,
                                            0.9216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            111.339,
                                            23.212
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0.269,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.065,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.307
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0.029,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.322,
                                                    -0.202
                                                ],
                                                [
                                                    -0.378,
                                                    0.042
                                                ],
                                                [
                                                    -0.269,
                                                    0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    0.326
                                                ],
                                                [
                                                    0.127,
                                                    0.306
                                                ],
                                                [
                                                    0.275,
                                                    0.184
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.089
                                                ],
                                                [
                                                    -0.03,
                                                    0.085
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.127,
                                                    -0.359
                                                ],
                                                [
                                                    -0.125,
                                                    -0.359
                                                ],
                                                [
                                                    -0.321,
                                                    -0.203
                                                ],
                                                [
                                                    -0.377,
                                                    0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.234
                                                ],
                                                [
                                                    -0.064,
                                                    0.325
                                                ],
                                                [
                                                    0.126,
                                                    0.306
                                                ],
                                                [
                                                    0.276,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0
                                                ],
                                                [
                                                    0.079,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.126,
                                                    0.359
                                                ],
                                                [
                                                    0.125,
                                                    0.36
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.234,
                                                    -0.235
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.374,
                                                    -8.941
                                                ],
                                                [
                                                    4.377,
                                                    -10.049
                                                ],
                                                [
                                                    3.688,
                                                    -10.917
                                                ],
                                                [
                                                    2.608,
                                                    -11.165
                                                ],
                                                [
                                                    1.609,
                                                    -10.686
                                                ],
                                                [
                                                    -8.449,
                                                    -0.627
                                                ],
                                                [
                                                    -8.909,
                                                    0.231
                                                ],
                                                [
                                                    -8.813,
                                                    1.2
                                                ],
                                                [
                                                    -8.196,
                                                    1.952
                                                ],
                                                [
                                                    -7.265,
                                                    2.235
                                                ],
                                                [
                                                    -2.792,
                                                    2.235
                                                ],
                                                [
                                                    -2.535,
                                                    2.298
                                                ],
                                                [
                                                    -2.336,
                                                    2.471
                                                ],
                                                [
                                                    -2.239,
                                                    2.717
                                                ],
                                                [
                                                    -2.265,
                                                    2.98
                                                ],
                                                [
                                                    -4.375,
                                                    8.941
                                                ],
                                                [
                                                    -4.377,
                                                    10.049
                                                ],
                                                [
                                                    -3.687,
                                                    10.917
                                                ],
                                                [
                                                    -2.607,
                                                    11.165
                                                ],
                                                [
                                                    -1.608,
                                                    10.685
                                                ],
                                                [
                                                    8.451,
                                                    0.626
                                                ],
                                                [
                                                    8.909,
                                                    -0.233
                                                ],
                                                [
                                                    8.813,
                                                    -1.201
                                                ],
                                                [
                                                    8.196,
                                                    -1.953
                                                ],
                                                [
                                                    7.265,
                                                    -2.235
                                                ],
                                                [
                                                    2.798,
                                                    -2.235
                                                ],
                                                [
                                                    2.54,
                                                    -2.298
                                                ],
                                                [
                                                    2.341,
                                                    -2.471
                                                ],
                                                [
                                                    2.243,
                                                    -2.718
                                                ],
                                                [
                                                    2.27,
                                                    -2.981
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            13.412
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -13.412
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5255,
                                            0.3804,
                                            0.9529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            36,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.624,
                                                    3.625
                                                ],
                                                [
                                                    -3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.624,
                                                    3.625
                                                ],
                                                [
                                                    3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.813
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.673,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.083
                                                ],
                                                [
                                                    -12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.083
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6863,
                                            0.5843,
                                            0.9961
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            526.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -7.5
                                                ],
                                                [
                                                    -254,
                                                    -31.5
                                                ],
                                                [
                                                    254,
                                                    -31.5
                                                ],
                                                [
                                                    278,
                                                    -7.5
                                                ],
                                                [
                                                    278,
                                                    31.5
                                                ],
                                                [
                                                    -278,
                                                    31.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=enterprise-ai-chatbot.c3d6e02c.js.map
